import * as React from 'react';

const CommissionImage = () => {
    return (
        <div className={'commission-empty-image'}>
            <svg
                viewBox="0 0 200 155"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    className="cls-12"
                    d="M 198.63,144.87 H 1.37 a 0.37,0.37 0 1 1 0,-0.74 h 197.26 a 0.37,0.37 0 0 1 0,0.74 z"
                    id="path172-5"/>
                <path
                    className="cls-4"
                    d="m 32.490475,142.53257 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463723,4.29319 23.309185,4.1377 12.845461,-0.1555 23.22954,-2.27555 23.199199,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.508384,0.56889 z"
                    id="path4"
                    />
                <path
                    className="cls-5"
                    d="m 54.275043,147.17848 c -5.666111,0 -10.952965,-0.37926 -15.018609,-1.11123 -4.786233,-0.84954 -7.205898,-2.02903 -7.240031,-3.50434 v -0.0265 l -0.151703,-5.8254 47.456528,-0.58026 0.147911,5.7723 c 0,0 0,0.0417 0,0.0796 0,1.47532 -2.389324,2.71549 -7.152802,3.6826 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z m -21.784568,-4.64591 0.474072,0.0266 c 0.01896,1.64218 8.72293,3.83429 22.827527,3.66363 6.181903,-0.0759 11.984547,-0.60302 16.338426,-1.4867 4.733138,-0.95952 6.401872,-2.07454 6.394287,-2.73824 v -0.0683 l -0.125155,-4.83933 -45.564032,0.55751 0.128947,4.88484 v 0 z"
                    id="path5"
                    />
                <path
                    className="cls-4"
                    d="m 32.48289,142.05849 c 0,0 0,0 0,0.0265 0.03034,2.44242 10.463723,4.2932 23.309184,4.13771 12.845462,-0.1555 23.229541,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.508384,0.56888 z"
                    id="path6"
                    />
                <path
                    className="cls-5"
                    d="m 54.263665,146.7044 c -5.666111,0 -10.949172,-0.37925 -15.014816,-1.11122 -4.801404,-0.85713 -7.221068,-2.02903 -7.240031,-3.51193 l 0.474072,-0.0303 h -0.474072 l -0.151703,-5.83299 47.456528,-0.58026 0.147911,5.75713 c 0,0.0303 0,0.0645 0,0.0948 0,1.47531 -2.389324,2.71548 -7.152802,3.68259 -4.410769,0.89505 -10.274094,1.4298 -16.516678,1.51703 z m -21.431858,-9.53454 0.128948,4.93035 c 0.01896,1.64219 8.722929,3.84188 22.827527,3.66363 6.181902,-0.0758 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401871,-2.07454 6.394286,-2.73824 v -0.0683 l -0.125155,-4.83933 z"
                    id="path7"
                    />
                <ellipse
                    className="cls-4"
                    cx="53.927418"
                    cy="137.09006"
                    rx="23.256088"
                    ry="4.4221458"
                    transform="rotate(-0.69999956)"
                    id="ellipse7"
                    />
                <path
                    className="cls-5"
                    d="m 54.12334,141.32273 c -5.666111,0 -10.949173,-0.37925 -15.014816,-1.11122 -4.786234,-0.84954 -7.205898,-2.02903 -7.240032,-3.50434 v 0 c 0,-1.47532 2.389324,-2.71549 7.152802,-3.6826 4.410769,-0.89504 10.274094,-1.4298 16.516678,-1.51703 6.242583,-0.0872 12.117286,0.31479 16.547017,1.09985 4.786234,0.84954 7.205899,2.02903 7.240032,3.50434 0.03413,1.47532 -2.389324,2.71549 -7.152802,3.6826 -4.410768,0.89504 -10.274094,1.4298 -16.516677,1.51703 z m -21.306703,-4.62694 c 0.01896,1.64977 8.722929,3.84947 22.827527,3.67122 6.181902,-0.0759 11.984546,-0.60302 16.338426,-1.4867 4.733137,-0.95952 6.401872,-2.07454 6.394286,-2.73824 -0.0076,-0.6637 -1.702867,-1.737 -6.447382,-2.58274 -4.372843,-0.75852 -10.190657,-1.16432 -16.368767,-1.08847 -14.112183,0.17446 -22.755468,2.57895 -22.732712,4.22872 z"
                    id="path8"
                    />
                <line
                    className="cls-4"
                    x1="77.167046"
                    y1="138.63759"
                    x2="77.204971"
                    y2="142.36189"
                    id="line8"
                    />
                <path
                    className="cls-5"
                    d="m 77.20497,142.83977 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.948144,0 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path9"
                    />
                <line
                    className="cls-4"
                    x1="69.593262"
                    y1="140.54526"
                    x2="69.631195"
                    y2="144.26578"
                    id="line9"
                    />
                <path
                    className="cls-5"
                    d="m 69.631192,144.73605 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47027 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 0.46648709,0.46648709 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path10"
                    />
                <line
                    className="cls-4"
                    x1="73.416183"
                    y1="139.74881"
                    x2="73.457901"
                    y2="143.46933"
                    id="line10"
                    />
                <path
                    className="cls-5"
                    d="m 73.457903,143.94341 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path11"
                    />
                <line
                    className="cls-4"
                    x1="66.058586"
                    y1="140.94348"
                    x2="66.100304"
                    y2="144.66779"
                    id="line11"
                    />
                <path
                    className="cls-5"
                    d="m 66.100301,145.14186 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47408 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path12"
                    />
                <line
                    className="cls-4"
                    x1="62.451839"
                    y1="141.37584"
                    x2="62.489769"
                    y2="145.10014"
                    id="line12"
                    />
                <path
                    className="cls-5"
                    d="m 62.489767,145.57421 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47027 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path13"
                    />
                <line
                    className="cls-4"
                    x1="58.697189"
                    y1="141.65269"
                    x2="58.735111"
                    y2="145.377"
                    id="line13"
                    />
                <path
                    className="cls-5"
                    d="m 58.719945,145.85107 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.948144,0 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path14"
                    />
                <line
                    className="cls-4"
                    x1="55.010803"
                    y1="141.79681"
                    x2="55.052521"
                    y2="145.51732"
                    id="line14"
                    />
                <path
                    className="cls-5"
                    d="m 55.052522,145.9914 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47787 0.46648709,0.46648709 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path15"
                    />
                <line
                    className="cls-4"
                    x1="51.252357"
                    y1="141.78163"
                    x2="51.290287"
                    y2="145.50595"
                    id="line15"
                    />
                <path
                    className="cls-5"
                    d="m 51.290284,145.98002 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.4627 0.46648709,0.46648709 0 0 1 0.477865,0.47028 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path16"
                    />
                <line
                    className="cls-4"
                    x1="47.49012"
                    y1="141.42892"
                    x2="47.528046"
                    y2="145.15324"
                    id="line16"
                    />
                <path
                    className="cls-5"
                    d="m 47.528047,145.62731 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path17"
                    />
                <line
                    className="cls-4"
                    x1="43.944061"
                    y1="141.07242"
                    x2="43.985779"
                    y2="144.79674"
                    id="line17"
                    />
                <path
                    className="cls-5"
                    d="m 43.985779,145.27081 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 0.46648709,0.46648709 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path18"
                    />
                <line
                    className="cls-4"
                    x1="40.109764"
                    y1="140.75006"
                    x2="40.14769"
                    y2="144.47437"
                    id="line18"
                    />
                <path
                    className="cls-5"
                    d="m 40.136312,144.94844 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path19"
                    />
                <line
                    className="cls-4"
                    x1="36.48785"
                    y1="139.98016"
                    x2="36.529572"
                    y2="143.70447"
                    id="line19"
                    />
                <path
                    className="cls-5"
                    d="m 36.525778,144.17855 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 0.48924256,0.48924256 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path20"
                    />
                <line
                    className="cls-4"
                    x1="32.934208"
                    y1="138.63759"
                    x2="32.975925"
                    y2="142.36189"
                    id="line20"
                    />
                <path
                    className="cls-5"
                    d="m 32.975925,142.83977 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72432 a 0.4740725,0.4740725 0 1 1 0.948145,0 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47028 z"
                    id="path21"
                    />
                <path
                    className="cls-4"
                    d="m 32.979718,142.93837 c 0.451316,2.36657 10.717825,4.1415 23.294014,3.986 12.576188,-0.15549 22.755468,-2.17314 23.187822,-4.55109"
                    id="path22"
                    />
                <path
                    className="cls-5"
                    d="m 54.790834,147.39086 c -10.892284,0 -21.720094,-1.46014 -22.273811,-4.38043 a 0.47492482,0.47492482 0 1 1 0.932974,-0.17825 c 0.299614,1.58151 8.612945,3.79258 22.819942,3.59916 6.037784,-0.0721 11.756992,-0.58406 16.065361,-1.4336 4.729344,-0.92918 6.545989,-2.04799 6.663559,-2.72307 a 0.47407225,0.47407225 0 0 1 0.932974,0.16308 c -0.530961,3.06061 -12.29933,4.80141 -23.646723,4.93035 z"
                    id="path23"
                    />
                <path
                    className="cls-4"
                    d="m 32.820429,136.93472 0.140326,5.35512 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463723,4.2932 23.309184,4.1377 12.845462,-0.15549 23.22954,-2.27554 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.3096 h -0.13274"
                    id="path24"
                    />
                <path
                    className="cls-5"
                    d="m 54.745323,146.93575 c -5.666112,0 -10.952965,-0.37926 -15.018609,-1.11123 -4.786233,-0.84953 -7.205898,-2.02902 -7.240031,-3.50434 v -0.0417 l -0.140326,-5.33236 a 0.47407225,0.47407225 0 0 1 0.462695,-0.48545 v 0 a 0.47407225,0.47407225 0 0 1 0.50062,0.46269 l 0.140325,5.35512 c 0.01896,1.68012 8.72293,3.87223 22.827527,3.70156 6.181903,-0.0759 11.984547,-0.60302 16.338426,-1.48669 4.733138,-0.95952 6.401872,-2.07454 6.394287,-2.73824 v -0.0531 l -0.128948,-4.99482 a 0.47407225,0.47407225 0 0 1 0.341332,-0.79644 h 0.58785 l 0.14791,5.75713 c 0,0.0303 0,0.0645 0,0.0948 0,1.47532 -2.389324,2.71549 -7.152802,3.6826 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z"
                    id="path25"
                    />
                <ellipse
                    className="cls-4"
                    cx="54.50378"
                    cy="137.33098"
                    rx="23.257252"
                    ry="4.4223671"
                    transform="rotate(-0.572939)"
                    id="ellipse25"/>
                <path
                    className="cls-5"
                    d="m 54.604997,141.55787 c -5.666111,0 -10.952965,-0.37925 -15.018608,-1.11122 -4.786234,-0.84954 -7.205899,-2.02903 -7.240032,-3.50434 v 0 c 0,-1.47532 2.389324,-2.71549 7.152802,-3.6826 4.410769,-0.89504 10.274094,-1.4298 16.516677,-1.51703 6.242584,-0.0872 12.117287,0.31479 16.547018,1.09985 4.786234,0.84954 7.205899,2.02903 7.240032,3.50434 0.03413,1.47532 -2.389324,2.71549 -7.152802,3.6826 -4.410769,0.89504 -10.274094,1.4298 -16.516678,1.51703 z m 2.943041,-8.86325 h -1.517031 c -6.181902,0.0759 -11.984547,0.60302 -16.338426,1.48669 -4.733138,0.95952 -6.401872,2.07454 -6.394287,2.73824 v 0 c 0,0.6637 1.702868,1.737 6.447383,2.58275 4.372842,0.75851 10.190657,1.16432 16.368767,1.08847 6.178109,-0.0759 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95953 6.401871,-2.07454 6.394286,-2.73824 -0.0076,-0.66371 -1.702867,-1.7408 -6.447383,-2.58275 -4.01634,-0.70542 -9.23872,-1.08847 -14.847942,-1.08847 z"
                    id="path26"
                    />
                <g
                    className="cls-6"
                    id="g39"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <line
                        className="cls-4"
                        x1="201.89"
                        y1="249.53"
                        x2="202"
                        y2="259.35001"
                        id="line26"/>
                    <path
                        className="cls-5"
                        d="m 202,260.6 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 A 1.25,1.25 0 0 1 202,260.6 Z"
                        id="path27"/>
                    <line
                        className="cls-4"
                        x1="181.92999"
                        y1="254.56"
                        x2="182.03"
                        y2="264.37"
                        id="line27"/>
                    <path
                        className="cls-5"
                        d="m 182,265.62 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path28"/>
                    <line
                        className="cls-4"
                        x1="192.00999"
                        y1="252.45"
                        x2="192.12"
                        y2="262.26999"
                        id="line28"/>
                    <path
                        className="cls-5"
                        d="m 192.12,263.52 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path29"/>
                    <line
                        className="cls-4"
                        x1="172.61"
                        y1="255.61"
                        x2="172.71001"
                        y2="265.42999"
                        id="line29"/>
                    <path
                        className="cls-5"
                        d="m 172.71,266.68 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.29,1.29 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path30"/>
                    <line
                        className="cls-4"
                        x1="163.10001"
                        y1="256.75"
                        x2="163.2"
                        y2="266.57001"
                        id="line30"/>
                    <path
                        className="cls-5"
                        d="m 163.2,267.82 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path31"/>
                    <line
                        className="cls-4"
                        x1="153.19"
                        y1="257.48001"
                        x2="153.3"
                        y2="267.29999"
                        id="line31"/>
                    <path
                        className="cls-5"
                        d="m 153.3,268.55 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path32"/>
                    <line
                        className="cls-4"
                        x1="143.48"
                        y1="257.85001"
                        x2="143.58"
                        y2="267.67001"
                        id="line32"/>
                    <path
                        className="cls-5"
                        d="m 143.58,268.92 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path33"/>
                    <line
                        className="cls-4"
                        x1="133.57001"
                        y1="257.82001"
                        x2="133.67"
                        y2="267.64001"
                        id="line33"/>
                    <path
                        className="cls-5"
                        d="m 133.67,268.89 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path34"/>
                    <line
                        className="cls-4"
                        x1="123.64"
                        y1="256.89001"
                        x2="123.75"
                        y2="266.70999"
                        id="line34"/>
                    <path
                        className="cls-5"
                        d="m 123.75,268 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.24,1.24 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path35"/>
                    <line
                        className="cls-4"
                        x1="114.3"
                        y1="255.95"
                        x2="114.41"
                        y2="265.76999"
                        id="line35"/>
                    <path
                        className="cls-5"
                        d="m 114.41,267 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path36"/>
                    <line
                        className="cls-4"
                        x1="104.19"
                        y1="255.10001"
                        x2="104.29"
                        y2="264.92001"
                        id="line36"/>
                    <path
                        className="cls-5"
                        d="m 104.29,266.17 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path37"/>
                    <line
                        className="cls-4"
                        x1="94.639999"
                        y1="253.07001"
                        x2="94.739998"
                        y2="262.89001"
                        id="line37"/>
                    <path
                        className="cls-5"
                        d="m 94.74,264.14 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path38"/>
                    <line
                        className="cls-4"
                        x1="85.269997"
                        y1="249.53"
                        x2="85.379997"
                        y2="259.35001"
                        id="line38"/>
                    <path
                        className="cls-5"
                        d="m 85.38,260.6 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path39"/>
                </g>
                <path
                    className="cls-5"
                    d="m 57.714911,133.57829 c 0.811612,0.11757 1.33878,0.31858 1.570128,0.6144 l 0.295821,0.37926 1.97214,-0.10999 0.379258,0.34513 -2.085918,0.11757 1.634601,2.12384 3.257825,-0.0759 0.887463,0.75851 -19.751746,1.13778 0.860915,-0.96711 11.88594,-0.67508 -0.914012,-2.16556 -4.346294,0.24652 0.09102,-0.37926 4.107362,-0.23135 -0.159289,-0.37926 c -0.09102,-0.21997 -0.337539,-0.37925 -0.728175,-0.44752 a 6.3525681,6.3525681 0 0 0 -0.997448,-0.0986 c -0.417183,0 -0.902633,0 -1.463935,0.0228 -0.561301,0.0228 -0.997448,0.0645 -1.327402,0.1024 a 6.758374,6.758374 0 0 0 -1.964555,0.43235 l -1.737001,0.0986 a 6.4473826,6.4473826 0 0 1 1.778719,-0.54993 q 0.595435,-0.11377 1.380498,-0.2048 c 0.515791,-0.0607 1.137774,-0.10998 1.896289,-0.15549 a 18.098182,18.098182 0 0 1 3.477794,0.0607 z"
                    id="path40"
                    />
                <path
                    className="cls-4"
                    d="m 36.286846,136.36584 c 0,0 0,0 0,0.0265 0.03034,2.44242 10.463722,4.2932 23.309184,4.13771 12.845462,-0.1555 23.22954,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.508384,0.56889 z"
                    id="path41"
                    />
                <path
                    className="cls-5"
                    d="m 58.067621,141.01174 c -5.666111,0 -10.949173,-0.37925 -15.014816,-1.11122 -4.786234,-0.85333 -7.221069,-2.02903 -7.240032,-3.50814 v -0.0228 l -0.151703,-5.82919 47.456529,-0.59544 0.14791,5.75713 c 0,0.0303 0,0.0645 0,0.0948 0,1.47531 -2.389324,2.71548 -7.152802,3.68259 -4.410768,0.89505 -10.274093,1.4298 -16.516677,1.51703 z m -21.780775,-4.6459 h 0.474072 c 0,0.66749 1.702868,1.74458 6.447383,2.58653 4.372842,0.75852 10.194449,1.16432 16.368766,1.08847 6.174317,-0.0759 11.984547,-0.60302 16.338426,-1.48669 4.733138,-0.95952 6.401872,-2.07454 6.394287,-2.73824 v -0.0683 l -0.125155,-4.83933 -45.548862,0.55371 0.128948,4.88484 v 0 z"
                    id="path42"
                    />
                <path
                    className="cls-4"
                    d="m 36.283053,135.89176 c 0,0 0,0 0,0.0265 0.03034,2.44242 10.463723,4.2932 23.309185,4.1377 12.845461,-0.15549 23.22954,-2.27554 23.199199,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.508384,0.56888 z"
                    id="path43"
                    />
                <path
                    className="cls-5"
                    d="m 58.063829,140.53767 c -5.666112,0 -10.949173,-0.37926 -15.018609,-1.11122 -4.786234,-0.84954 -7.205898,-2.02903 -7.240032,-3.50435 v -0.0228 l -0.151703,-5.82919 47.456529,-0.58027 0.14791,5.76472 c 0,0.0341 0,0.0683 0,0.1024 0,1.47152 -2.389324,2.7079 -7.152802,3.67501 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z m -21.780776,-4.6497 h 0.474072 c 0,0.66749 1.702868,1.74459 6.447383,2.58654 4.372842,0.75851 10.19445,1.16432 16.368767,1.08847 6.174317,-0.0759 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401871,-2.07454 6.394286,-2.73824 v -0.0683 l -0.121362,-4.83933 -45.556447,0.57268 0.128947,4.88484 v 0 z"
                    id="path44"
                    />
                <ellipse
                    className="cls-4"
                    cx="57.799076"
                    cy="130.96976"
                    rx="23.256088"
                    ry="4.4221458"
                    transform="rotate(-0.69999956)"
                    id="ellipse44"
                    />
                <path
                    className="cls-5"
                    d="m 57.927296,135.156 c -5.666112,0 -10.952965,-0.37925 -15.018609,-1.11122 -4.786234,-0.84954 -7.205898,-2.02903 -7.240031,-3.50434 v 0 c 0,-1.47532 2.389324,-2.71549 7.152802,-3.6826 4.410768,-0.89505 10.274093,-1.4298 16.516677,-1.51703 6.242583,-0.0872 12.117287,0.31479 16.547018,1.09985 4.786233,0.84954 7.205898,2.02903 7.240031,3.50434 0.03413,1.47531 -2.389324,2.71549 -7.152802,3.68259 -4.410768,0.89505 -10.274094,1.42981 -16.516677,1.51704 z m 2.980966,-8.86325 H 59.34572 c -6.181902,0.0759 -11.984547,0.60302 -16.338426,1.48669 -4.733137,0.95952 -6.401872,2.07454 -6.394287,2.73824 v 0 c 0,0.6637 1.702868,1.737 6.447383,2.58275 4.372842,0.75851 10.186865,1.16052 16.368767,1.08847 14.112182,-0.17446 22.755468,-2.57896 22.732712,-4.22873 -0.0038,-1.57392 -8.063021,-3.66742 -21.253607,-3.66742 z"
                    id="path45"
                    />
                <line
                    className="cls-4"
                    x1="80.963409"
                    y1="132.47086"
                    x2="81.001343"
                    y2="136.19518"
                    id="line45"
                    />
                <path
                    className="cls-5"
                    d="m 81.00134,136.66924 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path46"
                    />
                <line
                    className="cls-4"
                    x1="73.389633"
                    y1="134.37473"
                    x2="73.431351"
                    y2="138.09904"
                    id="line46"
                    />
                <path
                    className="cls-5"
                    d="m 73.431355,138.57312 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path47"
                    />
                <line
                    className="cls-4"
                    x1="77.216347"
                    y1="133.57829"
                    x2="77.254272"
                    y2="137.3026"
                    id="line47"
                    />
                <path
                    className="cls-5"
                    d="m 77.254273,137.77667 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path48"
                    />
                <line
                    className="cls-4"
                    x1="69.858742"
                    y1="134.77675"
                    x2="69.896675"
                    y2="138.50105"
                    id="line48"
                    />
                <path
                    className="cls-5"
                    d="M 69.896672,138.97513 A 0.47407225,0.47407225 0 0 1 69.4226,138.50485 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path49"
                    />
                <line
                    className="cls-4"
                    x1="66.248215"
                    y1="135.20911"
                    x2="66.289932"
                    y2="138.92963"
                    id="line49"
                    />
                <path
                    className="cls-5"
                    d="m 66.305101,139.40369 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.470278,0.47786 z"
                    id="path50"
                    />
                <line
                    className="cls-4"
                    x1="62.493557"
                    y1="135.48596"
                    x2="62.531487"
                    y2="139.20648"
                    id="line50"
                    />
                <path
                    className="cls-5"
                    d="m 62.531485,139.68055 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path51"
                    />
                <line
                    className="cls-4"
                    x1="58.81097"
                    y1="135.62628"
                    x2="58.848892"
                    y2="139.3506"
                    id="line51"
                    />
                <path
                    className="cls-5"
                    d="m 58.848892,139.8057 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03413,-3.70155 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path52"
                    />
                <line
                    className="cls-4"
                    x1="55.048733"
                    y1="135.6149"
                    x2="55.090446"
                    y2="139.33922"
                    id="line52"
                    />
                <path
                    className="cls-5"
                    d="m 55.090447,139.8057 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path53"
                    />
                <line
                    className="cls-4"
                    x1="51.286488"
                    y1="135.26219"
                    x2="51.324417"
                    y2="138.98651"
                    id="line53"
                    />
                <path
                    className="cls-5"
                    d="m 51.324417,139.46058 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 0.46648709,0.46648709 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path54"
                    />
                <line
                    className="cls-4"
                    x1="47.744225"
                    y1="134.9057"
                    x2="47.78215"
                    y2="138.63"
                    id="line54"
                    />
                <path
                    className="cls-5"
                    d="m 47.78215,139.10408 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03792,-3.72431 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path55"
                    />
                <line
                    className="cls-4"
                    x1="43.906136"
                    y1="134.58333"
                    x2="43.947853"
                    y2="138.30763"
                    id="line55"
                    />
                <path
                    className="cls-5"
                    d="m 43.92889,138.78171 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path56"
                    />
                <line
                    className="cls-4"
                    x1="40.288017"
                    y1="133.81343"
                    x2="40.325943"
                    y2="137.53775"
                    id="line56"
                    />
                <path
                    className="cls-5"
                    d="m 40.325941,138.01181 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path57"
                    />
                <line
                    className="cls-4"
                    x1="36.734371"
                    y1="132.47086"
                    x2="36.772293"
                    y2="136.19518"
                    id="line57"
                    />
                <path
                    className="cls-5"
                    d="m 36.772296,136.66924 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.462694,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47786 z"
                    id="path58"
                    />
                <path
                    className="cls-4"
                    d="m 36.779881,136.77164 c 0.451317,2.36657 10.717825,4.1415 23.294014,3.986 12.576189,-0.1555 22.755468,-2.17315 23.187822,-4.55109"
                    id="path59"
                    />
                <path
                    className="cls-5"
                    d="m 58.590997,141.24309 c -10.892284,0 -21.723887,-1.46014 -22.277603,-4.38043 a 0.47492482,0.47492482 0 1 1 0.932974,-0.17825 c 0.299614,1.58151 8.605359,3.79258 22.819942,3.59916 6.037784,-0.0721 11.756992,-0.58406 16.06536,-1.4336 4.729345,-0.92918 6.54599,-2.04799 6.66356,-2.72307 a 0.47407225,0.47407225 0 1 1 0.932974,0.16308 c -0.530961,3.06061 -12.299331,4.80141 -23.646724,4.93036 z"
                    id="path60"
                    />
                <path
                    className="cls-4"
                    d="m 36.620593,130.76799 0.140325,5.35512 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463723,4.2932 23.309184,4.1377 12.845462,-0.15549 23.229541,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 h -0.140325"
                    id="path61"
                    />
                <path
                    className="cls-5"
                    d="m 58.537901,140.76902 c -5.666112,0 -10.949173,-0.37926 -15.014816,-1.11123 -4.786234,-0.84953 -7.205899,-2.02903 -7.240032,-3.50434 v -0.0417 l -0.140325,-5.33236 a 0.47407225,0.47407225 0 0 1 0.462694,-0.48545 v 0 a 0.47407225,0.47407225 0 0 1 0.496828,0.4589 l 0.140325,5.35512 c 0,0.69404 1.702868,1.77113 6.447383,2.61309 4.372842,0.75851 10.19445,1.16053 16.372559,1.08847 6.17811,-0.0721 11.984547,-0.60302 16.338426,-1.48669 4.733138,-0.95953 6.401872,-2.07454 6.394287,-2.73825 v -0.0683 l -0.128948,-4.99483 a 0.47407225,0.47407225 0 0 1 0.341332,-0.79644 h 0.584057 l 0.147911,5.7761 a 0.78127107,0.78127107 0 0 1 0,0.0834 c 0,1.47152 -2.389324,2.7079 -7.152802,3.67501 -4.410769,0.89505 -10.274094,1.4298 -16.516678,1.51703 z"
                    id="path62"
                    />
                <ellipse
                    className="cls-4"
                    cx="58.273098"
                    cy="131.20485"
                    rx="23.256088"
                    ry="4.4221458"
                    transform="rotate(-0.69999956)"
                    id="ellipse62"
                    />
                <path
                    className="cls-5"
                    d="m 58.401368,135.38735 c -5.666111,0 -10.949173,-0.37926 -15.014816,-1.11123 -4.786234,-0.84953 -7.205898,-2.02902 -7.240032,-3.50434 v 0 c 0,-1.47531 2.389324,-2.71548 7.152802,-3.68259 4.410769,-0.89505 10.274094,-1.4298 16.516678,-1.51703 6.242583,-0.0872 12.136249,0.31478 16.547017,1.09985 4.786234,0.84953 7.205899,2.02903 7.240032,3.50434 0.03413,1.47531 -2.389324,2.71548 -7.152802,3.68259 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z M 37.10225,130.76041 c 0.01896,1.64977 8.722929,3.84567 22.827527,3.67121 14.104598,-0.17446 22.755468,-2.57895 22.732713,-4.22872 -0.02276,-1.64978 -8.72293,-3.8343 -22.827527,-3.67122 -14.104598,0.16308 -22.755468,2.57895 -22.732713,4.22873 z"
                    id="path63"
                    />
                <g
                    className="cls-6"
                    id="g76"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <line
                        className="cls-4"
                        x1="211.91"
                        y1="233.27"
                        x2="212.00999"
                        y2="243.09"
                        id="line63"/>
                    <path
                        className="cls-5"
                        d="m 212,244.34 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path64"/>
                    <line
                        className="cls-4"
                        x1="191.94"
                        y1="238.28999"
                        x2="192.05"
                        y2="248.11"
                        id="line64"/>
                    <path
                        className="cls-5"
                        d="m 192,249.36 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path65"/>
                    <line
                        className="cls-4"
                        x1="202.03"
                        y1="236.19"
                        x2="202.13"
                        y2="246.00999"
                        id="line65"/>
                    <path
                        className="cls-5"
                        d="m 202.13,247.26 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 1 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path66"/>
                    <line
                        className="cls-4"
                        x1="182.62"
                        y1="239.35001"
                        x2="182.73"
                        y2="249.17"
                        id="line66"/>
                    <path
                        className="cls-5"
                        d="m 182.73,250.42 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path67"/>
                    <line
                        className="cls-4"
                        x1="173.11"
                        y1="240.49001"
                        x2="173.22"
                        y2="250.3"
                        id="line67"/>
                    <path
                        className="cls-5"
                        d="m 173.22,251.55 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path68"/>
                    <line
                        className="cls-4"
                        x1="163.21001"
                        y1="241.22"
                        x2="163.31"
                        y2="251.03"
                        id="line68"/>
                    <path
                        className="cls-5"
                        d="m 163.31,252.28 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 A 1.25,1.25 0 0 1 163.2,240 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path69"/>
                    <line
                        className="cls-4"
                        x1="153.49001"
                        y1="241.59"
                        x2="153.60001"
                        y2="251.41"
                        id="line69"/>
                    <path
                        className="cls-5"
                        d="m 153.6,252.66 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.22,1.22 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path70"/>
                    <line
                        className="cls-4"
                        x1="143.58"
                        y1="241.56"
                        x2="143.67999"
                        y2="251.38"
                        id="line70"/>
                    <path
                        className="cls-5"
                        d="m 143.68,252.63 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.23,1.23 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path71"/>
                    <line
                        className="cls-4"
                        x1="133.66"
                        y1="240.63"
                        x2="133.75999"
                        y2="250.45"
                        id="line71"/>
                    <path
                        className="cls-5"
                        d="m 133.76,251.7 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path72"/>
                    <line
                        className="cls-4"
                        x1="124.32"
                        y1="239.69"
                        x2="124.42"
                        y2="249.50999"
                        id="line72"/>
                    <path
                        className="cls-5"
                        d="m 124.42,250.76 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.22,1.22 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path73"/>
                    <line
                        className="cls-4"
                        x1="114.2"
                        y1="238.84"
                        x2="114.3"
                        y2="248.66"
                        id="line73"/>
                    <path
                        className="cls-5"
                        d="m 114.3,249.91 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path74"/>
                    <line
                        className="cls-4"
                        x1="104.65"
                        y1="236.81"
                        x2="104.76"
                        y2="246.63"
                        id="line74"/>
                    <path
                        className="cls-5"
                        d="m 104.76,247.88 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path75"/>
                    <line
                        className="cls-4"
                        x1="95.290001"
                        y1="233.27"
                        x2="95.389999"
                        y2="243.09"
                        id="line75"/>
                    <path
                        className="cls-5"
                        d="m 95.39,244.34 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 A 1.25,1.25 0 0 1 95.27,232 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path76"/>
                </g>
                <path
                    className="cls-5"
                    d="m 61.511282,127.41156 c 0.811612,0.11757 1.33878,0.31858 1.570127,0.6144 l 0.295821,0.37925 1.972141,-0.10998 0.379258,0.34512 -2.085918,0.11757 1.634601,2.12385 3.257824,-0.0759 0.887464,0.75851 -19.751747,1.13778 0.860916,-0.96711 11.885939,-0.67508 -0.914011,-2.16556 -4.346295,0.24651 0.09102,-0.37925 4.107362,-0.23135 -0.159288,-0.37926 c -0.09102,-0.21997 -0.337539,-0.37926 -0.728175,-0.44752 a 6.3525681,6.3525681 0 0 0 -0.997448,-0.0986 c -0.417184,0 -0.902634,0 -1.463935,0.0228 -0.561302,0.0228 -0.997448,0.0645 -1.327402,0.1024 a 6.758374,6.758374 0 0 0 -1.964556,0.43235 l -1.737,0.0986 a 6.4473826,6.4473826 0 0 1 1.778719,-0.54993 q 0.595434,-0.11377 1.380498,-0.2048 c 0.515791,-0.0607 1.137773,-0.10998 1.896289,-0.15549 a 18.098182,18.098182 0 0 1 3.477794,0.0607 z"
                    id="path77"
                    />
                <path
                    className="cls-4"
                    d="m 34.932895,130.19531 c 0,0 0,0 0,0.0265 0.03034,2.44242 10.463723,4.2932 23.309185,4.1377 12.845461,-0.15549 23.22954,-2.27555 23.199199,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136532,-5.30961 -46.508384,0.56889 z"
                    id="path78"
                    />
                <path
                    className="cls-5"
                    d="m 56.717463,134.84122 c -5.666111,0 -10.952965,-0.37926 -15.018608,-1.11123 -4.786234,-0.84953 -7.205899,-2.02903 -7.240032,-3.50434 v -0.0228 l -0.151703,-5.8292 47.456529,-0.58026 0.14791,5.75713 c 0,0.0341 0,0.0683 0,0.1024 0,1.47152 -2.389324,2.7079 -7.152802,3.67501 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z m -21.784568,-4.64591 h 0.474073 c 0,0.66749 1.702867,1.74459 6.447382,2.58654 4.372843,0.75851 10.190657,1.16053 16.368767,1.08847 6.178109,-0.0721 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401872,-2.07454 6.394286,-2.73824 v -0.0683 l -0.121362,-4.83933 -45.552654,0.57268 0.128947,4.88484 v 0 z"
                    id="path79"
                    />
                <path
                    className="cls-4"
                    d="m 34.929103,129.72124 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463723,4.2932 23.309184,4.1377 12.845462,-0.1555 23.22954,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.512177,0.56889 z"
                    id="path80"
                    />
                <path
                    className="cls-5"
                    d="m 56.709878,134.36715 c -5.666111,0 -10.949172,-0.37926 -15.014816,-1.11123 -4.786233,-0.84954 -7.205898,-2.02903 -7.240031,-3.50434 v -0.0265 l -0.151704,-5.8254 47.456529,-0.58026 0.14791,5.7723 a 0.7585156,0.7585156 0 0 1 0,0.0796 c 0,1.47532 -2.389324,2.71549 -7.152802,3.6826 -4.410768,0.89505 -10.274093,1.4298 -16.516677,1.51703 z m -21.780775,-4.64591 0.474072,0.0266 c 0.01896,1.64218 8.722929,3.83809 22.827527,3.66363 14.104598,-0.17446 22.755468,-2.57896 22.732713,-4.22873 v -0.0683 l -0.125156,-4.83933 -45.564032,0.5613 0.128948,4.88484 v 0 z"
                    id="path81"
                    />
                <ellipse
                    className="cls-4"
                    cx="56.517414"
                    cy="124.78114"
                    rx="23.256088"
                    ry="4.4221458"
                    transform="rotate(-0.69999956)"
                    id="ellipse81"
                    />
                <path
                    className="cls-5"
                    d="m 56.569553,128.98927 c -5.666112,0 -10.949173,-0.37926 -15.014816,-1.11122 -4.786234,-0.84954 -7.205899,-2.02903 -7.240032,-3.50435 -0.03413,-1.47531 2.389324,-2.71548 7.152802,-3.68259 4.410768,-0.89505 10.274094,-1.4298 16.516677,-1.51703 6.242584,-0.0872 12.117287,0.31478 16.547018,1.09985 4.786234,0.84953 7.205898,2.02903 7.240032,3.50434 0.03413,1.47531 -2.389324,2.71548 -7.152802,3.68259 -4.410769,0.89505 -10.274094,1.4298 -16.516678,1.51703 z m 2.980966,-8.86325 H 57.99177 c -6.181903,0.0759 -11.984547,0.60302 -16.338426,1.48669 -4.733138,0.95952 -6.401872,2.07454 -6.394287,2.73824 v 0 c 0,0.6637 1.702868,1.74079 6.447383,2.58274 4.372842,0.75852 10.190657,1.16053 16.368766,1.08847 6.17811,-0.0721 11.984547,-0.60302 16.338426,-1.48669 4.733138,-0.95952 6.401872,-2.07454 6.394287,-2.73824 -0.0038,-1.5815 -8.055436,-3.67121 -21.2574,-3.67121 z"
                    id="path82"
                    />
                <line
                    className="cls-4"
                    x1="79.609467"
                    y1="126.30412"
                    x2="79.647385"
                    y2="130.02844"
                    id="line82"
                    />
                <path
                    className="cls-5"
                    d="m 79.64739,130.50251 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path83"
                    />
                <line
                    className="cls-4"
                    x1="72.035683"
                    y1="128.20799"
                    x2="72.077408"
                    y2="131.93231"
                    id="line83"
                    />
                <path
                    className="cls-5"
                    d="m 72.077404,132.40638 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 0.48544998,0.48544998 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path84"
                    />
                <line
                    className="cls-4"
                    x1="75.862396"
                    y1="127.41156"
                    x2="75.900322"
                    y2="131.13586"
                    id="line84"
                    />
                <path
                    className="cls-5"
                    d="m 75.900323,131.60994 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 1 1 0.948144,0 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path85"
                    />
                <line
                    className="cls-4"
                    x1="68.504799"
                    y1="128.61002"
                    x2="68.542717"
                    y2="132.33054"
                    id="line85"
                    />
                <path
                    className="cls-5"
                    d="m 68.542722,132.8046 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03792,-3.72431 a 0.47407225,0.47407225 0 0 1 0.948144,0 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path86"
                    />
                <line
                    className="cls-4"
                    x1="64.894264"
                    y1="129.03857"
                    x2="64.935982"
                    y2="132.76288"
                    id="line86"
                    />
                <path
                    className="cls-5"
                    d="m 64.93598,133.23696 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 1 1 0.948144,0 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47786 z"
                    id="path87"
                    />
                <line
                    className="cls-4"
                    x1="61.13961"
                    y1="129.31543"
                    x2="61.177532"
                    y2="133.03975"
                    id="line87"
                    />
                <path
                    className="cls-5"
                    d="m 61.177535,133.51382 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 0.46648709,0.46648709 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path88"
                    />
                <line
                    className="cls-4"
                    x1="57.457016"
                    y1="129.45955"
                    x2="57.494942"
                    y2="133.18385"
                    id="line88"
                    />
                <path
                    className="cls-5"
                    d="m 57.494942,133.65793 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 0.46269452,0.46269452 0 0 1 0.477864,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path89"
                    />
                <line
                    className="cls-4"
                    x1="53.694778"
                    y1="129.44818"
                    x2="53.736496"
                    y2="133.16869"
                    id="line89"
                    />
                <path
                    className="cls-5"
                    d="m 53.736497,133.64276 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 0.46648709,0.46648709 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47786 z"
                    id="path90"
                    />
                <line
                    className="cls-4"
                    x1="49.932541"
                    y1="129.09167"
                    x2="49.970463"
                    y2="132.81598"
                    id="line90"
                    />
                <path
                    className="cls-5"
                    d="m 49.970467,133.29005 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path91"
                    />
                <line
                    className="cls-4"
                    x1="46.390274"
                    y1="128.73897"
                    x2="46.4282"
                    y2="132.46327"
                    id="line91"
                    />
                <path
                    className="cls-5"
                    d="m 46.428199,132.93734 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47027 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 0.46269452,0.46269452 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path92"
                    />
                <line
                    className="cls-4"
                    x1="42.552185"
                    y1="128.4166"
                    x2="42.593903"
                    y2="132.13712"
                    id="line92"
                    />
                <path
                    className="cls-5"
                    d="m 42.593903,132.59981 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path93"
                    />
                <line
                    className="cls-4"
                    x1="38.934067"
                    y1="127.64291"
                    x2="38.971992"
                    y2="131.36722"
                    id="line93"
                    />
                <path
                    className="cls-5"
                    d="m 38.971991,131.84129 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.466487,0.47787 z"
                    id="path94"
                    />
                <line
                    className="cls-4"
                    x1="35.380421"
                    y1="126.30412"
                    x2="35.418343"
                    y2="130.02464"
                    id="line94"
                    />
                <path
                    className="cls-5"
                    d="m 35.418345,130.49872 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path95"
                    />
                <path
                    className="cls-4"
                    d="m 35.425931,130.60491 c 0.451316,2.36657 10.717825,4.14149 23.294014,3.986 12.576188,-0.1555 22.755468,-2.17315 23.187821,-4.55109"
                    id="path96"
                    />
                <path
                    className="cls-5"
                    d="m 57.233254,135.07257 c -10.892284,0 -21.720094,-1.46015 -22.273811,-4.38043 a 0.4749251,0.4749251 0 1 1 0.932975,-0.17825 c 0.299613,1.5815 8.605359,3.79258 22.819941,3.59915 6.037785,-0.0721 11.756992,-0.58405 16.065361,-1.43359 4.729345,-0.92918 6.545989,-2.04799 6.663559,-2.72307 a 0.47407225,0.47407225 0 1 1 0.932975,0.16308 c -0.534754,3.06061 -12.299331,4.8014 -23.646724,4.93035 z"
                    id="path97"
                    />
                <path
                    className="cls-4"
                    d="m 35.266642,124.59747 0.136533,5.34753 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463723,4.2932 23.309184,4.1377 12.845462,-0.15549 23.229541,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 L 81.775026,124.021 h -0.11757"
                    id="path98"
                    />
                <path
                    className="cls-5"
                    d="m 57.202913,134.59849 c -5.666111,0 -10.952965,-0.37925 -15.018608,-1.11122 -4.786234,-0.84954 -7.205899,-2.02903 -7.240032,-3.50434 v -0.0379 l -0.140325,-5.33236 a 0.47420905,0.47420905 0 1 1 0.948144,-0.0228 l 0.125155,5.35512 c 0.01896,1.68011 8.72293,3.87222 22.827527,3.70156 6.181902,-0.0759 11.984547,-0.60302 16.338426,-1.48669 4.733138,-0.95953 6.401872,-2.07454 6.394287,-2.73824 v -0.0683 l -0.128948,-4.99483 a 0.47407225,0.47407225 0 0 1 0.341332,-0.79644 h 0.584057 l 0.147911,5.77231 c 0,0 0,0.0417 0,0.0796 0,1.47531 -2.389324,2.71549 -7.152802,3.68259 -4.410769,0.89505 -10.274094,1.42981 -16.516678,1.51703 z"
                    id="path99"
                    />
                <ellipse
                    className="cls-4"
                    cx="56.995182"
                    cy="125.02008"
                    rx="23.256088"
                    ry="4.4221458"
                    transform="rotate(-0.69999956)"
                    id="ellipse99"
                    />
                <path
                    className="cls-5"
                    d="m 57.05121,129.22062 c -5.666111,0 -10.952965,-0.37926 -15.018609,-1.11123 -4.786233,-0.84953 -7.205898,-2.02903 -7.240031,-3.50434 -0.03413,-1.47531 2.389324,-2.71548 7.152802,-3.68259 4.410768,-0.89505 10.274094,-1.4298 16.516677,-1.51703 6.242584,-0.0872 12.117287,0.31478 16.547018,1.09984 4.786234,0.84954 7.205898,2.02903 7.240032,3.50435 0.03413,1.47531 -2.389325,2.71548 -7.152803,3.68259 -4.410768,0.89505 -10.274093,1.4298 -16.516677,1.51703 z m 2.980967,-8.86326 h -1.562543 c -6.181902,0.0759 -11.984546,0.60302 -16.338426,1.48669 -4.733137,0.95953 -6.401871,2.07454 -6.394286,2.73825 v 0 c 0,0.6637 1.702867,1.737 6.447383,2.58274 4.372842,0.75852 10.190657,1.16432 16.368766,1.08847 6.17811,-0.0759 11.984547,-0.60302 16.338426,-1.48669 4.733138,-0.95952 6.401872,-2.07454 6.394287,-2.73824 -0.0076,-1.58151 -8.063021,-3.67122 -21.253607,-3.67122 z"
                    id="path100"
                    />
                <g
                    className="cls-6"
                    id="g113"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <line
                        className="cls-4"
                        x1="208.34"
                        y1="217.00999"
                        x2="208.44"
                        y2="226.83"
                        id="line100"/>
                    <path
                        className="cls-5"
                        d="m 208.44,228.08 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path101"/>
                    <line
                        className="cls-4"
                        x1="188.37"
                        y1="222.03"
                        x2="188.48"
                        y2="231.85001"
                        id="line101"/>
                    <path
                        className="cls-5"
                        d="m 188.48,233.1 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path102"/>
                    <line
                        className="cls-4"
                        x1="198.46001"
                        y1="219.92999"
                        x2="198.56"
                        y2="229.75"
                        id="line102"/>
                    <path
                        className="cls-5"
                        d="m 198.56,231 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path103"/>
                    <line
                        className="cls-4"
                        x1="179.05"
                        y1="223.09"
                        x2="179.16"
                        y2="232.89999"
                        id="line103"/>
                    <path
                        className="cls-5"
                        d="m 179.16,234.15 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path104"/>
                    <line
                        className="cls-4"
                        x1="169.53999"
                        y1="224.22"
                        x2="169.64999"
                        y2="234.03999"
                        id="line104"/>
                    <path
                        className="cls-5"
                        d="m 169.65,235.29 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path105"/>
                    <line
                        className="cls-4"
                        x1="159.64"
                        y1="224.95"
                        x2="159.74001"
                        y2="234.77"
                        id="line105"/>
                    <path
                        className="cls-5"
                        d="m 159.74,236 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path106"/>
                    <line
                        className="cls-4"
                        x1="149.92"
                        y1="225.33"
                        x2="150.03"
                        y2="235.14999"
                        id="line106"/>
                    <path
                        className="cls-5"
                        d="m 150,236.4 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 A 1.25,1.25 0 0 1 150,236.4 Z"
                        id="path107"/>
                    <line
                        className="cls-4"
                        x1="140.00999"
                        y1="225.3"
                        x2="140.11"
                        y2="235.11"
                        id="line107"/>
                    <path
                        className="cls-5"
                        d="m 140.11,236.36 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 A 1.25,1.25 0 0 1 140,224 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path108"/>
                    <line
                        className="cls-4"
                        x1="130.09"
                        y1="224.36"
                        x2="130.19"
                        y2="234.17999"
                        id="line108"/>
                    <path
                        className="cls-5"
                        d="m 130.19,235.43 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.23,1.23 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path109"/>
                    <line
                        className="cls-4"
                        x1="120.75"
                        y1="223.42999"
                        x2="120.85"
                        y2="233.25"
                        id="line109"/>
                    <path
                        className="cls-5"
                        d="m 120.85,234.5 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path110"/>
                    <line
                        className="cls-4"
                        x1="110.63"
                        y1="222.58"
                        x2="110.73"
                        y2="232.39"
                        id="line110"/>
                    <path
                        className="cls-5"
                        d="m 110.73,233.64 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path111"/>
                    <line
                        className="cls-4"
                        x1="101.08"
                        y1="220.53999"
                        x2="101.19"
                        y2="230.36"
                        id="line111"/>
                    <path
                        className="cls-5"
                        d="m 101.19,231.61 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path112"/>
                    <line
                        className="cls-4"
                        x1="91.720001"
                        y1="217"
                        x2="91.82"
                        y2="226.82001"
                        id="line112"/>
                    <path
                        className="cls-5"
                        d="m 91.82,228.07 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 A 1.25,1.25 0 0 1 93,217 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path113"/>
                </g>
                <path
                    className="cls-5"
                    d="m 60.157332,121.24103 c 0.811611,0.11757 1.33878,0.31858 1.570127,0.6144 l 0.295821,0.37926 1.972141,-0.10999 0.379257,0.34513 -2.085918,0.11757 1.634602,2.12384 3.257824,-0.0759 0.887463,0.75852 -19.751746,1.13777 0.860915,-0.96711 11.88594,-0.67508 -0.914011,-2.16556 -4.346295,0.24652 0.09102,-0.37926 4.107362,-0.23135 -0.159288,-0.37925 c -0.09102,-0.21997 -0.33754,-0.37926 -0.728175,-0.44753 a 6.3525681,6.3525681 0 0 0 -0.997448,-0.0986 c -0.417184,0 -0.902634,0 -1.463935,0.0228 -0.561302,0.0228 -0.997448,0.0645 -1.327403,0.1024 a 6.758374,6.758374 0 0 0 -1.964555,0.43235 l -1.737001,0.0986 a 6.4473826,6.4473826 0 0 1 1.778719,-0.54992 q 0.595435,-0.11378 1.380499,-0.2048 c 0.51579,-0.0607 1.137773,-0.10999 1.896289,-0.1555 a 18.098182,18.098182 0 0 1 3.477794,0.0607 z"
                    id="path114"
                    />
                <path
                    className="cls-4"
                    d="m 32.433586,121.95025 0.0531,2.07833 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463722,4.2932 23.309184,4.1377 12.845462,-0.1555 23.22954,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.508384,0.56889 v 0.28444"
                    id="path115"
                    />
                <path
                    className="cls-5"
                    d="m 54.271251,128.67449 c -5.666112,0 -10.949173,-0.37926 -15.014817,-1.11123 -4.786233,-0.84954 -7.205898,-2.02903 -7.240031,-3.50434 v -0.0417 l -0.05689,-2.03661 a 0.47420955,0.47420955 0 1 1 0.948145,-0.0228 l 0.0531,2.07833 c 0.01896,1.68012 8.722929,3.87981 22.827527,3.70156 6.181902,-0.0759 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401871,-2.07454 6.394286,-2.73824 v -0.0683 l -0.125155,-4.87725 -45.601958,0.57647 a 0.47407225,0.47407225 0 0 1 -0.910218,-0.17067 l -0.01896,-0.75851 47.456528,-0.58027 0.147911,5.77231 c 0,0 0,0.0417 0,0.0796 0,1.47531 -2.389324,2.71549 -7.152802,3.68259 -4.410768,0.89505 -10.274094,1.42981 -16.516677,1.51703 z"
                    id="path116"
                    />
                <path
                    className="cls-4"
                    d="m 32.437379,121.73786 0.0493,1.81665 c 0,0 0,0 0,0.0265 0.03034,2.44243 10.463722,4.2932 23.309184,4.13771 12.845462,-0.1555 23.22954,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.515969,0.55751 0.01896,0.75851"
                    id="path117"
                    />
                <path
                    className="cls-5"
                    d="m 54.267458,128.20041 c -5.666112,0 -10.952965,-0.37925 -15.018609,-1.11122 -4.786233,-0.84954 -7.205898,-2.02903 -7.240031,-3.50434 l -0.04551,-1.83561 a 0.47420905,0.47420905 0 1 1 0.948144,-0.0228 l 0.0493,1.81665 c 0.01896,1.68011 8.722929,3.87601 22.827527,3.70156 6.181902,-0.0759 11.984546,-0.60302 16.338426,-1.4867 4.733137,-0.95952 6.401871,-2.07454 6.394286,-2.73824 v -0.0683 l -0.125155,-4.83933 -45.564032,0.55751 v 0.28444 a 0.47420905,0.47420905 0 1 1 -0.948144,0.0228 l -0.03413,-1.24776 47.456529,-0.58027 0.147911,5.75714 c 0,0.0303 0,0.0645 0,0.0948 0,1.47531 -2.389325,2.71549 -7.152803,3.68259 -4.410768,0.89505 -10.274093,1.42981 -16.516677,1.51703 z"
                    id="path118"
                    />
                <ellipse
                    className="cls-4"
                    cx="54.151211"
                    cy="118.58501"
                    rx="23.256088"
                    ry="4.4221458"
                    transform="rotate(-0.69999956)"
                    id="ellipse118"
                    />
                <path
                    className="cls-5"
                    d="m 54.127133,122.82254 c -5.666112,0 -10.952966,-0.37926 -15.018609,-1.11123 -4.786234,-0.84953 -7.205898,-2.02903 -7.240032,-3.50434 v 0 c 0,-1.47531 2.389324,-2.71548 7.152802,-3.68259 4.410769,-0.89505 10.274094,-1.4298 16.516678,-1.51703 6.242583,-0.0872 12.117286,0.31478 16.547017,1.09985 4.786234,0.84953 7.205899,2.02902 7.240032,3.50434 0.03413,1.47531 -2.389324,2.71548 -7.152802,3.68259 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z m -21.310496,-4.63453 c 0.01896,1.64977 8.722929,3.83809 22.827527,3.67121 6.181902,-0.0758 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401872,-2.07454 6.394286,-2.73824 -0.0076,-0.6637 -1.702867,-1.74079 -6.447382,-2.58274 -4.372843,-0.75852 -10.19445,-1.16432 -16.368767,-1.08847 -14.112183,0.17446 -22.755468,2.57895 -22.732712,4.22872 z"
                    id="path119"
                    />
                <line
                    className="cls-4"
                    x1="77.167046"
                    y1="120.13739"
                    x2="77.204971"
                    y2="123.85791"
                    id="line119"
                    />
                <path
                    className="cls-5"
                    d="m 77.20497,124.33199 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.47028 l 0.03792,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path120"
                    />
                <line
                    className="cls-4"
                    x1="69.593262"
                    y1="122.04127"
                    x2="69.631195"
                    y2="125.76179"
                    id="line120"
                    />
                <path
                    className="cls-5"
                    d="m 69.631192,126.23586 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03413,3.73948 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path121"
                    />
                <line
                    className="cls-4"
                    x1="73.416183"
                    y1="121.24483"
                    x2="73.457901"
                    y2="124.96535"
                    id="line121"
                    />
                <path
                    className="cls-5"
                    d="m 73.457903,125.43942 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.45511 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path122"
                    />
                <line
                    className="cls-4"
                    x1="66.058586"
                    y1="122.43949"
                    x2="66.100304"
                    y2="126.1638"
                    id="line122"
                    />
                <path
                    className="cls-5"
                    d="m 66.100301,126.63787 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path123"
                    />
                <line
                    className="cls-4"
                    x1="62.451839"
                    y1="122.87184"
                    x2="62.489769"
                    y2="126.59615"
                    id="line123"
                    />
                <path
                    className="cls-5"
                    d="m 62.489767,127.07023 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path124"
                    />
                <line
                    className="cls-4"
                    x1="58.697189"
                    y1="123.1487"
                    x2="58.735111"
                    y2="126.87301"
                    id="line124"
                    />
                <path
                    className="cls-5"
                    d="m 58.719945,127.34708 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47027 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470278,0.47786 z"
                    id="path125"
                    />
                <line
                    className="cls-4"
                    x1="55.010803"
                    y1="123.29282"
                    x2="55.052521"
                    y2="127.01334"
                    id="line125"
                    />
                <path
                    className="cls-5"
                    d="m 55.052522,127.48741 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47787 0.48544998,0.48544998 0 0 1 0.477865,0.47028 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path126"
                    />
                <line
                    className="cls-4"
                    x1="51.252357"
                    y1="123.27765"
                    x2="51.290287"
                    y2="127.00196"
                    id="line126"
                    />
                <path
                    className="cls-5"
                    d="m 51.290284,127.47603 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path127"
                    />
                <line
                    className="cls-4"
                    x1="47.49012"
                    y1="122.92494"
                    x2="47.528046"
                    y2="126.64925"
                    id="line127"
                    />
                <path
                    className="cls-5"
                    d="m 47.528047,127.12332 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path128"
                    />
                <line
                    className="cls-4"
                    x1="43.944061"
                    y1="122.56844"
                    x2="43.985779"
                    y2="126.29275"
                    id="line128"
                    />
                <path
                    className="cls-5"
                    d="m 43.985779,126.76682 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.455109,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.47028 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47786 z"
                    id="path129"
                    />
                <line
                    className="cls-4"
                    x1="40.109764"
                    y1="122.24606"
                    x2="40.14769"
                    y2="125.97038"
                    id="line129"
                    />
                <path
                    className="cls-5"
                    d="m 40.136312,126.44445 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47027 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path130"
                    />
                <line
                    className="cls-4"
                    x1="36.48785"
                    y1="121.47617"
                    x2="36.529572"
                    y2="125.20049"
                    id="line130"
                    />
                <path
                    className="cls-5"
                    d="m 36.525778,125.67456 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path131"
                    />
                <line
                    className="cls-4"
                    x1="32.934208"
                    y1="120.13361"
                    x2="32.975925"
                    y2="123.85791"
                    id="line131"
                    />
                <path
                    className="cls-5"
                    d="m 32.975925,124.33199 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.45511 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.466487,-0.49303 0.48165741,0.48165741 0 0 1 0.477865,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path132"
                    />
                <path
                    className="cls-4"
                    d="m 32.979718,124.43818 c 0.451316,2.36657 10.717825,4.14149 23.294014,3.986 12.576188,-0.1555 22.755468,-2.17315 23.187822,-4.5511"
                    id="path133"
                    />
                <path
                    className="cls-5"
                    d="m 54.794626,128.90583 c -10.892284,0 -21.723886,-1.46014 -22.277603,-4.38042 a 0.47492482,0.47492482 0 1 1 0.932974,-0.17825 c 0.299614,1.5815 8.60536,3.79257 22.819942,3.59915 6.037784,-0.0721 11.756992,-0.58405 16.065361,-1.43359 4.729344,-0.92918 6.545989,-2.04799 6.663559,-2.72307 a 0.47407225,0.47407225 0 0 1 0.932974,0.16308 c -0.530961,3.06061 -12.29933,4.8014 -23.646723,4.93035 z"
                    id="path134"
                    />
                <path
                    className="cls-4"
                    d="m 32.820429,118.43073 0.03793,1.4336"
                    id="path135"
                    />
                <path
                    className="cls-5"
                    d="m 32.858355,120.3384 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.46269 l -0.03793,-1.4336 a 0.47407225,0.47407225 0 0 1 0.462695,-0.48545 0.46648709,0.46648709 0 0 1 0.50062,0.4627 l 0.03793,1.43359 a 0.47407225,0.47407225 0 0 1 -0.462695,0.48545 z"
                    id="path136"
                    />
                <path
                    className="cls-4"
                    d="m 32.896281,121.38136 0.06447,2.40449 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463723,4.2932 23.309184,4.1377 12.845462,-0.15549 23.22954,-2.27554 23.1992,-4.70658 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 h -0.13274"
                    id="path137"
                    />
                <path
                    className="cls-5"
                    d="m 54.74153,128.42797 c -5.666111,0 -10.949172,-0.37926 -15.014816,-1.11123 -4.786233,-0.84953 -7.205898,-2.02902 -7.240031,-3.50434 v -0.0417 l -0.06447,-2.38174 a 0.47420905,0.47420905 0 1 1 0.948144,-0.0228 l 0.06447,2.40829 v 0.0303 c 0.01896,1.64218 8.722929,3.84188 22.827527,3.66363 6.181902,-0.0759 11.984547,-0.60302 16.338426,-1.48669 4.733137,-0.95953 6.401872,-2.07454 6.394287,-2.73824 v -0.0683 l -0.132741,-4.98724 a 0.47407225,0.47407225 0 0 1 0.341332,-0.79644 h 0.584057 l 0.147911,5.76092 c 0,0.0303 0,0.0645 0,0.0948 0,1.47531 -2.389324,2.71548 -7.152802,3.68259 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z"
                    id="path138"
                    />
                <ellipse
                    className="cls-4"
                    cx="54.628979"
                    cy="118.82394"
                    rx="23.256088"
                    ry="4.4221458"
                    transform="rotate(-0.69999956)"
                    id="ellipse138"
                    />
                <path
                    className="cls-5"
                    d="m 54.601205,123.05389 c -5.666112,0 -10.949173,-0.37926 -15.014816,-1.11123 -4.786234,-0.84954 -7.205899,-2.02903 -7.240032,-3.50434 v 0 c 0,-1.47531 2.389324,-2.71549 7.152802,-3.68259 4.410769,-0.89505 10.274094,-1.42981 16.516677,-1.51704 6.242584,-0.0872 12.13625,0.31479 16.547018,1.09985 4.786234,0.84954 7.205898,2.02903 7.240032,3.50434 0.03413,1.47532 -2.389324,2.71549 -7.152802,3.6826 -4.410769,0.89505 -10.274094,1.4298 -16.516678,1.51703 z m 2.946833,-8.86326 h -1.517031 c -6.181902,0.0759 -11.984547,0.60302 -16.338426,1.48669 -4.733138,0.95952 -6.401872,2.07454 -6.394287,2.73824 v 0 c 0,0.6637 1.702868,1.7408 6.447383,2.58275 4.372842,0.75851 10.19445,1.16053 16.368767,1.08847 6.174316,-0.0721 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401871,-2.07454 6.394286,-2.73824 -0.0076,-0.6637 -1.702867,-1.737 -6.447383,-2.58275 -4.01634,-0.70542 -9.242512,-1.08847 -14.851735,-1.08847 z"
                    id="path139"
                    />
                <g
                    className="cls-6"
                    id="g152"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <line
                        className="cls-4"
                        x1="201.89"
                        y1="200.74001"
                        x2="202"
                        y2="210.56"
                        id="line139"/>
                    <path
                        className="cls-5"
                        d="m 202,211.81 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.27,1.27 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path140"/>
                    <line
                        className="cls-4"
                        x1="181.92999"
                        y1="205.77"
                        x2="182.03"
                        y2="215.58"
                        id="line140"/>
                    <path
                        className="cls-5"
                        d="m 182,216.83 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path141"/>
                    <line
                        className="cls-4"
                        x1="192.00999"
                        y1="203.67"
                        x2="192.12"
                        y2="213.48"
                        id="line141"/>
                    <path
                        className="cls-5"
                        d="m 192.12,214.73 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.23,1.23 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path142"/>
                    <line
                        className="cls-4"
                        x1="172.61"
                        y1="206.82001"
                        x2="172.71001"
                        y2="216.64"
                        id="line142"/>
                    <path
                        className="cls-5"
                        d="m 172.71,217.89 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.23,1.23 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path143"/>
                    <line
                        className="cls-4"
                        x1="163.10001"
                        y1="207.96001"
                        x2="163.2"
                        y2="217.78"
                        id="line143"/>
                    <path
                        className="cls-5"
                        d="m 163.2,219 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path144"/>
                    <line
                        className="cls-4"
                        x1="153.19"
                        y1="208.69"
                        x2="153.3"
                        y2="218.50999"
                        id="line144"/>
                    <path
                        className="cls-5"
                        d="m 153.3,219.76 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path145"/>
                    <line
                        className="cls-4"
                        x1="143.48"
                        y1="209.07001"
                        x2="143.58"
                        y2="218.88"
                        id="line145"/>
                    <path
                        className="cls-5"
                        d="m 143.58,220.13 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path146"/>
                    <line
                        className="cls-4"
                        x1="133.57001"
                        y1="209.03"
                        x2="133.67"
                        y2="218.85001"
                        id="line146"/>
                    <path
                        className="cls-5"
                        d="m 133.67,220.1 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 1 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path147"/>
                    <line
                        className="cls-4"
                        x1="123.64"
                        y1="208.10001"
                        x2="123.75"
                        y2="217.92"
                        id="line147"/>
                    <path
                        className="cls-5"
                        d="m 123.75,219.17 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path148"/>
                    <line
                        className="cls-4"
                        x1="114.3"
                        y1="207.16"
                        x2="114.41"
                        y2="216.98"
                        id="line148"/>
                    <path
                        className="cls-5"
                        d="m 114.41,218.23 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path149"/>
                    <line
                        className="cls-4"
                        x1="104.19"
                        y1="206.31"
                        x2="104.29"
                        y2="216.13"
                        id="line149"/>
                    <path
                        className="cls-5"
                        d="m 104.29,217.38 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path150"/>
                    <line
                        className="cls-4"
                        x1="94.639999"
                        y1="204.28"
                        x2="94.739998"
                        y2="214.10001"
                        id="line150"/>
                    <path
                        className="cls-5"
                        d="m 94.74,215.35 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 A 1.25,1.25 0 0 1 94.63,203 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path151"/>
                    <line
                        className="cls-4"
                        x1="85.269997"
                        y1="200.74001"
                        x2="85.379997"
                        y2="210.56"
                        id="line151"/>
                    <path
                        className="cls-5"
                        d="m 85.38,211.81 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path152"/>
                </g>
                <path
                    className="cls-5"
                    d="m 57.714911,115.0743 c 0.811612,0.11757 1.33878,0.31858 1.570128,0.6144 l 0.295821,0.37926 1.97214,-0.10999 0.379258,0.34513 -2.085918,0.11757 1.634601,2.12384 3.257825,-0.0759 0.887463,0.75852 -19.751746,1.13777 0.860915,-0.96711 11.88594,-0.67508 -0.914012,-2.16556 -4.346294,0.24652 0.09102,-0.37926 4.107362,-0.23135 -0.159289,-0.37925 c -0.09102,-0.21997 -0.337539,-0.37926 -0.728175,-0.44753 a 6.3525681,6.3525681 0 0 0 -0.997448,-0.0986 c -0.417183,0 -0.902633,0 -1.463935,0.0228 -0.561301,0.0228 -0.997448,0.0645 -1.327402,0.1024 a 6.758374,6.758374 0 0 0 -1.964555,0.43235 l -1.737001,0.0986 a 6.4473826,6.4473826 0 0 1 1.778719,-0.54992 q 0.595435,-0.11378 1.380498,-0.2048 c 0.515791,-0.0607 1.137774,-0.10999 1.896289,-0.1555 a 18.098182,18.098182 0 0 1 3.477794,0.0607 z"
                    id="path153"
                    />
                <path
                    className="cls-4"
                    d="m 35.247679,118.79103 c 0,0 0,0 0,0.0266 0.03034,2.44242 10.463723,4.2932 23.309185,4.1377 12.845461,-0.1555 23.22954,-2.27555 23.199199,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136532,-5.30961 -46.508384,0.56889 z"
                    id="path154"
                    />
                <path
                    className="cls-5"
                    d="m 57.032247,123.43694 c -5.666111,0 -10.952965,-0.37926 -15.018608,-1.11123 -4.786234,-0.84954 -7.205899,-2.02903 -7.240032,-3.50434 v -0.0228 l -0.151703,-5.82919 47.456529,-0.58026 0.14791,5.7723 a 0.80023396,0.80023396 0 0 1 0,0.0872 c 0,1.47152 -2.389324,2.7079 -7.152802,3.67501 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z m -21.784568,-4.64591 h 0.474073 c 0,0.66749 1.702867,1.74458 6.447382,2.58654 4.372843,0.75851 10.190657,1.16432 16.368767,1.08847 6.178109,-0.0759 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95953 6.401872,-2.07454 6.394286,-2.73824 v -0.0531 l -0.125155,-4.83933 -45.560239,0.55751 0.128947,4.88484 v 0 z"
                    id="path155"
                    />
                <path
                    className="cls-4"
                    d="m 35.240094,118.31696 c 0,0 0,0 0,0.0265 0.03034,2.44242 10.463723,4.2932 23.309185,4.13771 12.845461,-0.1555 23.22954,-2.27555 23.199199,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 -46.508384,0.56889 z"
                    id="path156"
                    />
                <path
                    className="cls-5"
                    d="m 57.02087,122.96286 c -5.666112,0 -10.949173,-0.37925 -15.014817,-1.11122 -4.786233,-0.84954 -7.205898,-2.02903 -7.240031,-3.50434 v -0.0266 l -0.151703,-5.82161 47.456528,-0.58026 0.147911,5.7723 c 0,0 0,0.0417 0,0.0797 0,1.47531 -2.389324,2.71548 -7.152802,3.68259 -4.410768,0.89505 -10.274094,1.4298 -16.516677,1.51703 z m -21.780776,-4.6459 0.474072,0.0265 c 0.01896,1.64219 8.72293,3.83809 22.827527,3.66364 14.104598,-0.17446 22.755468,-2.57896 22.732713,-4.22873 v -0.0683 l -0.125155,-4.83174 -45.564032,0.55372 0.128947,4.88484 v 0 z"
                    id="path157"
                    />
                <path
                    className="cls-4"
                    d="m 52.18154,108.48659 c -9.860703,0.63337 -17.108319,2.43863 -17.066601,4.47904 0.03034,2.44242 10.463723,4.2932 23.309185,4.1377 12.845461,-0.15549 23.22954,-2.27555 23.199199,-4.70659 -0.03034,-2.43104 -10.463723,-4.2932 -23.309184,-4.1377 l -1.33878,0.0228"
                    id="path158"
                    />
                <path
                    className="cls-5"
                    d="m 56.884337,117.58499 c -5.666112,0 -10.949173,-0.37926 -15.014816,-1.11123 -4.786234,-0.84953 -7.205899,-2.02903 -7.240032,-3.50434 -0.04551,-3.64846 14.590048,-4.76727 17.525503,-4.9569 a 0.46648709,0.46648709 0 0 1 0.504413,0.44373 0.47407225,0.47407225 0 0 1 -0.443732,0.50442 c -11.502889,0.73576 -16.65321,2.77996 -16.630454,3.99737 0,0.66371 1.702867,1.7408 6.447382,2.58275 4.372843,0.75852 10.190657,1.16053 16.368767,1.08847 6.17811,-0.0721 11.984547,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401872,-2.07454 6.394287,-2.73824 -0.01896,-1.64977 -8.72293,-3.8343 -22.827527,-3.67122 l -1.334988,0.0228 v 0 a 0.474075,0.474075 0 0 1 0,-0.94815 l 1.346365,-0.0228 c 6.242584,-0.0759 12.117287,0.31478 16.547018,1.09985 4.786234,0.84953 7.205898,2.02902 7.240032,3.50434 0.03413,1.47531 -2.389325,2.71548 -7.152803,3.68259 -4.410768,0.89505 -10.274093,1.4298 -16.516677,1.51703 z"
                    id="path159"
                    />
                <line
                    className="cls-4"
                    x1="79.924248"
                    y1="114.89984"
                    x2="79.962173"
                    y2="118.62415"
                    id="line159"
                    />
                <path
                    className="cls-5"
                    d="m 79.958381,119.09823 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.4740725,0.4740725 0 1 1 0.948145,0 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.474073,0.47028 z"
                    id="path160"
                    />
                <line
                    className="cls-4"
                    x1="72.350471"
                    y1="116.80372"
                    x2="72.392189"
                    y2="120.52803"
                    id="line160"
                    />
                <path
                    className="cls-5"
                    d="m 72.373225,121.0021 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path161"
                    />
                <line
                    className="cls-4"
                    x1="76.177177"
                    y1="116.00728"
                    x2="76.215111"
                    y2="119.73159"
                    id="line161"
                    />
                <path
                    className="cls-5"
                    d="m 76.215107,120.20566 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.462694,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474073,0.47028 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47786 z"
                    id="path162"
                    />
                <line
                    className="cls-4"
                    x1="68.815788"
                    y1="117.20573"
                    x2="68.857506"
                    y2="120.92625"
                    id="line162"
                    />
                <path
                    className="cls-5"
                    d="m 68.857506,121.40032 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.470279,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470278,0.47786 z"
                    id="path163"
                    />
                <line
                    className="cls-4"
                    x1="65.209045"
                    y1="117.63429"
                    x2="65.250763"
                    y2="121.3586"
                    id="line163"
                    />
                <path
                    className="cls-5"
                    d="m 65.250764,121.83268 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path164"
                    />
                <line
                    className="cls-4"
                    x1="61.454395"
                    y1="117.91116"
                    x2="61.492317"
                    y2="121.63546"
                    id="line164"
                    />
                <path
                    className="cls-5"
                    d="m 61.492319,122.10953 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.48545 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path165"
                    />
                <line
                    className="cls-4"
                    x1="57.768009"
                    y1="118.05527"
                    x2="57.809727"
                    y2="121.77958"
                    id="line165"
                    />
                <path
                    className="cls-5"
                    d="m 57.809726,122.25365 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path166"
                    />
                <line
                    className="cls-4"
                    x1="54.009563"
                    y1="118.0401"
                    x2="54.047485"
                    y2="121.7644"
                    id="line166"
                    />
                <path
                    className="cls-5"
                    d="m 54.047489,122.23848 a 0.47407225,0.47407225 0 0 1 -0.474073,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47786 z"
                    id="path167"
                    />
                <line
                    className="cls-4"
                    x1="50.247326"
                    y1="117.68739"
                    x2="50.285248"
                    y2="121.4117"
                    id="line167"
                    />
                <path
                    className="cls-5"
                    d="m 50.285251,121.88577 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.4740725,0.4740725 0 0 1 0.948145,0 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.470279,0.47787 z"
                    id="path168"
                    />
                <line
                    className="cls-4"
                    x1="46.705059"
                    y1="117.33468"
                    x2="46.742981"
                    y2="121.0552"
                    id="line168"
                    />
                <path
                    className="cls-5"
                    d="m 46.742983,121.52927 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path169"
                    />
                <line
                    className="cls-4"
                    x1="42.866966"
                    y1="117.00851"
                    x2="42.904896"
                    y2="120.73283"
                    id="line169"
                    />
                <path
                    className="cls-5"
                    d="m 42.904894,121.22207 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47027 l 0.03793,3.72432 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47786 z"
                    id="path170"
                    />
                <line
                    className="cls-4"
                    x1="39.245056"
                    y1="116.23862"
                    x2="39.286777"
                    y2="119.96294"
                    id="line170"
                    />
                <path
                    className="cls-5"
                    d="m 39.286775,120.43701 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72431 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47787 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path171"
                    />
                <line
                    className="cls-4"
                    x1="35.69141"
                    y1="114.89606"
                    x2="35.733128"
                    y2="118.62036"
                    id="line171"
                    />
                <path
                    className="cls-5"
                    d="m 35.733129,119.09444 a 0.47407225,0.47407225 0 0 1 -0.474072,-0.47028 l -0.03793,-3.72432 a 0.47407225,0.47407225 0 0 1 0.47028,-0.47786 v 0 a 0.47407225,0.47407225 0 0 1 0.474072,0.47028 l 0.03793,3.72431 a 0.47407225,0.47407225 0 0 1 -0.47028,0.47787 z"
                    id="path172"
                    />
                <path
                    className="cls-4"
                    d="m 35.740714,119.20063 c 0.451317,2.36657 10.717826,4.14149 23.294015,3.986 12.576188,-0.1555 22.755468,-2.17315 23.187821,-4.5511"
                    id="path173"
                    />
                <path
                    className="cls-5"
                    d="m 57.548038,123.66828 c -10.892284,0 -21.720094,-1.46014 -22.273811,-4.38042 a 0.4749251,0.4749251 0 1 1 0.932975,-0.17825 c 0.299613,1.5815 8.605359,3.79257 22.819941,3.59915 6.037785,-0.0721 11.756992,-0.58406 16.065361,-1.43359 4.729345,-0.92918 6.545989,-2.04799 6.663559,-2.72307 a 0.47407225,0.47407225 0 1 1 0.932975,0.16308 c -0.534754,3.06061 -12.299331,4.8014 -23.646724,4.93035 z"
                    id="path174"
                    />
                <path
                    className="cls-4"
                    d="m 35.585219,113.19318 0.13274,5.37409 c 0,0 0,0 0,0.0265 0.03034,2.44243 10.463723,4.2932 23.309184,4.13771 12.845462,-0.1555 23.229541,-2.27555 23.1992,-4.70659 q 0,-0.0379 0,-0.0721 l -0.136533,-5.30961 h -0.11757"
                    id="path175"
                    />
                <path
                    className="cls-5"
                    d="m 57.502527,123.19421 c -5.666111,0 -10.952965,-0.37926 -15.018609,-1.11122 -4.786233,-0.84954 -7.205898,-2.02903 -7.240031,-3.50435 v -0.0417 l -0.140326,-5.33237 a 0.47420955,0.47420955 0 1 1 0.948145,-0.0228 l 0.140325,5.35512 c 0,0.69404 1.702868,1.77113 6.447383,2.61308 4.372842,0.75852 10.19445,1.16432 16.368767,1.08847 6.174317,-0.0759 11.984546,-0.60302 16.338426,-1.48669 4.733137,-0.95952 6.401871,-2.07454 6.394286,-2.73824 v -0.0683 l -0.128948,-4.99482 a 0.47407225,0.47407225 0 0 1 0.341332,-0.79644 h 0.58785 l 0.147911,5.7723 c 0,0 0,0.0417 0,0.0797 0,1.47531 -2.389325,2.71548 -7.152803,3.68259 -4.410768,0.89505 -10.274093,1.4298 -16.516677,1.51703 z"
                    id="path176"
                    />
                <path
                    className="cls-4"
                    d="m 52.947641,108.70656 c -10.016199,0.6144 -17.396555,2.43484 -17.370007,4.49421 0.03034,2.44242 10.463722,4.2932 23.309184,4.1377 12.845462,-0.15549 23.22954,-2.27555 23.1992,-4.70659 -0.03034,-2.43104 -10.471308,-4.30457 -23.305392,-4.14529 l -1.596675,0.0303"
                    id="path177"
                    />
                <path
                    className="cls-5"
                    d="m 57.362202,117.80875 c -5.666112,0 -10.949173,-0.37926 -15.018609,-1.11122 -4.786234,-0.84954 -7.205898,-2.02903 -7.240032,-3.50435 -0.04551,-3.69017 14.832773,-4.79002 17.825117,-4.97586 a 0.48165741,0.48165741 0 0 1 0.481657,0.45132 0.47407225,0.47407225 0 0 1 -0.443731,0.50062 c -11.700103,0.7168 -16.941446,2.77996 -16.926276,4.01634 0,0.6637 1.702868,1.737 6.447383,2.58274 4.372842,0.75852 10.186864,1.16053 16.368766,1.08847 6.181903,-0.072 11.984547,-0.60302 16.338426,-1.48669 4.733138,-0.95952 6.401872,-2.07454 6.394287,-2.73824 -0.01896,-1.64977 -8.722929,-3.84567 -22.827527,-3.67121 l -1.58909,0.0303 a 0.47421157,0.47421157 0 0 1 -0.02276,-0.94815 l 1.600468,-0.0303 c 6.234998,-0.0758 12.117287,0.31479 16.547018,1.09985 4.786233,0.84954 7.205898,2.02903 7.240031,3.50434 0.03413,1.47531 -2.389324,2.71549 -7.152802,3.6826 -4.410768,0.89504 -10.274093,1.4298 -16.516677,1.51703 z"
                    id="path178"
                    />
                <g
                    className="cls-6"
                    id="g191"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <line
                        className="cls-4"
                        x1="209.16"
                        y1="186.94"
                        x2="209.27"
                        y2="196.75"
                        id="line178"/>
                    <path
                        className="cls-5"
                        d="m 209.27,198 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path179"/>
                    <line
                        className="cls-4"
                        x1="189.2"
                        y1="191.96001"
                        x2="189.3"
                        y2="201.78"
                        id="line179"/>
                    <path
                        className="cls-5"
                        d="m 189.3,203 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 A 1.25,1.25 0 0 1 189.3,203 Z"
                        id="path180"/>
                    <line
                        className="cls-4"
                        x1="199.28"
                        y1="189.86"
                        x2="199.39"
                        y2="199.67999"
                        id="line180"/>
                    <path
                        className="cls-5"
                        d="m 199.39,200.93 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path181"/>
                    <line
                        className="cls-4"
                        x1="179.88"
                        y1="193.00999"
                        x2="179.98"
                        y2="202.83"
                        id="line181"/>
                    <path
                        className="cls-5"
                        d="m 180,204.08 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 1.28,1.28 0 0 1 1.26,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path182"/>
                    <line
                        className="cls-4"
                        x1="170.37"
                        y1="194.14999"
                        x2="170.47"
                        y2="203.97"
                        id="line182"/>
                    <path
                        className="cls-5"
                        d="m 170.47,205.22 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path183"/>
                    <line
                        className="cls-4"
                        x1="160.47"
                        y1="194.88"
                        x2="160.57001"
                        y2="204.7"
                        id="line183"/>
                    <path
                        className="cls-5"
                        d="m 160.57,205.95 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path184"/>
                    <line
                        className="cls-4"
                        x1="150.75"
                        y1="195.25999"
                        x2="150.85001"
                        y2="205.08"
                        id="line184"/>
                    <path
                        className="cls-5"
                        d="m 150.85,206.33 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path185"/>
                    <line
                        className="cls-4"
                        x1="140.84"
                        y1="195.22"
                        x2="140.94"
                        y2="205.03999"
                        id="line185"/>
                    <path
                        className="cls-5"
                        d="m 140.94,206.29 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 1 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path186"/>
                    <line
                        className="cls-4"
                        x1="130.91"
                        y1="194.28999"
                        x2="131.02"
                        y2="204.11"
                        id="line186"/>
                    <path
                        className="cls-5"
                        d="m 131,205.36 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.25,-1.3 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path187"/>
                    <line
                        className="cls-4"
                        x1="121.57"
                        y1="193.36"
                        x2="121.68"
                        y2="203.17"
                        id="line187"/>
                    <path
                        className="cls-5"
                        d="m 121.68,204.42 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 2.5,0 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path188"/>
                    <line
                        className="cls-4"
                        x1="111.46"
                        y1="192.5"
                        x2="111.56"
                        y2="202.32001"
                        id="line188"/>
                    <path
                        className="cls-5"
                        d="m 111.56,203.57 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path189"/>
                    <line
                        className="cls-4"
                        x1="101.91"
                        y1="190.47"
                        x2="102.01"
                        y2="200.28999"
                        id="line189"/>
                    <path
                        className="cls-5"
                        d="m 102,201.54 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 a 1.25,1.25 0 0 1 -1.24,1.26 z"
                        id="path190"/>
                    <line
                        className="cls-4"
                        x1="92.540001"
                        y1="186.92999"
                        x2="92.650002"
                        y2="196.75"
                        id="line190"/>
                    <path
                        className="cls-5"
                        d="m 92.65,198 a 1.25,1.25 0 0 1 -1.25,-1.24 l -0.1,-9.82 a 1.25,1.25 0 0 1 1.24,-1.26 v 0 a 1.25,1.25 0 0 1 1.25,1.24 l 0.1,9.82 A 1.25,1.25 0 0 1 92.66,198 Z"
                        id="path191"/>
                </g>
                <path
                    className="cls-5"
                    d="m 59.774281,109.65092 c 0.758516,-0.0341 1.388084,-0.0455 1.896289,-0.0379 0.508206,0.008 0.993656,0.0303 1.395669,0.0645 a 6.4473826,6.4473826 0 0 1 1.82423,0.37926 l -1.737001,0.0759 a 6.758374,6.758374 0 0 0 -1.998688,-0.23514 q -0.496828,0 -1.331195,0.0303 c -0.557509,0.0228 -1.042959,0.0645 -1.45635,0.12516 a 6.3525681,6.3525681 0 0 0 -0.982278,0.19721 c -0.379258,0.12137 -0.606812,0.29203 -0.678871,0.51959 l -0.121363,0.37925 4.111155,-0.18204 0.125155,0.3603 -4.350087,0.18962 -0.690249,2.24521 11.901109,-0.50441 0.951937,0.87608 -19.774501,0.85713 0.804026,-0.84575 3.246447,-0.25031 1.410839,-2.27555 -2.085918,0.091 0.348917,-0.37926 1.972141,-0.0872 0.254103,-0.41339 c 0.197214,-0.32237 0.705419,-0.57268 1.517031,-0.75852 a 18.098182,18.098182 0 0 1 3.447453,-0.42097 z"
                    id="path192"
                    />
                <path
                    className="cls-7"
                    d="m 123.57303,143.04457 c 0,0 0,0.0228 0,0.0341 0,3.20852 -13.67983,5.81023 -30.55301,5.81023 -16.873179,0 -30.553008,-2.60171 -30.553008,-5.81023 q 0,-0.0493 0,-0.0948 l 0.09102,-6.97455 h 61.098438 z"
                    id="path193"
                    />
                <path
                    className="cls-8"
                    d="m 123.57303,142.42258 c 0,0 0,0.0228 0,0.0341 0,3.20852 -13.67983,5.81023 -30.55301,5.81023 -16.873179,0 -30.553008,-2.60171 -30.553008,-5.81023 q 0,-0.0493 0,-0.0948 l 0.09102,-6.97455 h 61.098438 z"
                    id="path194"
                    />
                <ellipse
                    className="cls-7"
                    cx="93.099663"
                    cy="135.38736"
                    rx="30.553007"
                    ry="5.8102293"
                    id="ellipse194"
                    />
                <path
                    className="cls-9"
                    d="m 64.810825,144.48954 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94815 z"
                    id="path195"
                    />
                <path
                    className="cls-9"
                    d="m 74.789098,146.87128 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94815 z"
                    id="path196"
                    />
                <path
                    className="cls-9"
                    d="m 69.752554,145.87383 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94815 z"
                    id="path197"
                    />
                <path
                    className="cls-9"
                    d="m 79.438798,147.34156 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94815 z"
                    id="path198"
                    />
                <path
                    className="cls-9"
                    d="m 84.183313,147.84976 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path199"
                    />
                <path
                    className="cls-9"
                    d="m 89.125042,148.14938 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94815 z"
                    id="path200"
                    />
                <path
                    className="cls-9"
                    d="m 93.964372,148.28212 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94815 z"
                    id="path201"
                    />
                <path
                    className="cls-9"
                    d="m 98.921271,148.20247 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path202"
                    />
                <path
                    className="cls-9"
                    d="m 103.85162,147.6791 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94815 z"
                    id="path203"
                    />
                <path
                    className="cls-9"
                    d="m 108.48995,147.15572 a 0.9481445,0.9481445 0 0 1 -0.94815,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.94815,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94814 z"
                    id="path204"
                    />
                <path
                    className="cls-9"
                    d="m 113.52649,146.67027 a 0.9481445,0.9481445 0 0 1 -0.94815,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.94815,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94814 z"
                    id="path205"
                    />
                <path
                    className="cls-9"
                    d="m 118.26342,145.60076 a 0.9481445,0.9481445 0 0 1 -0.94815,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.94815,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94814 z"
                    id="path206"
                    />
                <path
                    className="cls-9"
                    d="m 122.91691,143.78033 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94815 z"
                    id="path207"
                    />
                <path
                    className="cls-3"
                    d="m 92.379074,149.66641 c -14.487648,0 -30.272357,-2.0973 -31.000532,-5.98848 a 0.47457264,0.47457264 0 1 1 0.932974,-0.17446 c 0.409598,2.18452 11.085705,5.21479 30.067558,5.21479 18.981856,0 29.680716,-3.03406 30.071356,-5.21859 a 0.47407225,0.47407225 0 1 1 0.93297,0.16688 c -0.69025,3.90635 -16.49771,5.99986 -31.004326,5.99986 z"
                    id="path208"
                    />
                <path
                    className="cls-3"
                    d="m 92.379074,149.05201 c -15.041364,0 -31.02708,-2.20349 -31.02708,-6.2843 0,-0.0455 0,-0.0948 0,-0.14033 l 0.09861,-7.40311 h 0.625775 a 0.47407225,0.47407225 0 0 1 0.310992,0.83057 l -0.08723,6.62185 c 0,0.0531 0,0.072 0,0.091 0,2.18073 10.710241,5.33615 30.078936,5.33615 19.368693,0 30.078933,-3.15542 30.078933,-5.33615 v -0.0417 l 0.0986,-7.03523 a 0.47407225,0.47407225 0 1 1 0.94814,0 l -0.0986,7.03523 c 0.004,4.12632 -15.98192,6.32602 -31.027073,6.32602 z"
                    id="path209"
                    />
                <path
                    className="cls-3"
                    d="m 92.473889,141.98264 c -15.041365,0 -31.027081,-2.20348 -31.027081,-6.2843 0,-4.08081 15.989509,-6.2843 31.027081,-6.2843 15.037571,0 31.027081,2.20349 31.027081,6.2843 a 1.7294156,1.7294156 0 0 1 -0.22376,0.83437 0.47521006,0.47521006 0 0 1 -0.83437,-0.45511 0.78127107,0.78127107 0 0 0 0.10619,-0.37926 c 0,-2.18073 -10.71024,-5.33616 -30.078934,-5.33616 -19.368696,0 -30.078936,3.15543 -30.078936,5.33616 0,2.18073 10.71024,5.33616 30.078936,5.33616 12.287954,0 23.278844,-1.38429 27.996814,-3.52331 a 0.47407225,0.47407225 0 0 1 0.37925,0.86471 c -4.81278,2.18832 -15.95537,3.60674 -28.372271,3.60674 z"
                    id="path210"
                    />
                <g
                    className="cls-6"
                    id="g223"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <path
                        className="cls-3"
                        d="m 166.42,264.68 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path211"/>
                    <path
                        className="cls-3"
                        d="m 192.73,271 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 V 269 a 2,2 0 0 1 -2,2 z"
                        id="path212"/>
                    <path
                        className="cls-3"
                        d="m 179.45,268.35 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path213"/>
                    <path
                        className="cls-3"
                        d="m 205,272.19 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path214"/>
                    <path
                        className="cls-3"
                        d="m 217.5,273.53 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path215"/>
                    <path
                        className="cls-3"
                        d="m 230.52,274.33 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path216"/>
                    <path
                        className="cls-3"
                        d="m 243.29,274.67 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path217"/>
                    <path
                        className="cls-3"
                        d="m 256.31,274.47 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path218"/>
                    <path
                        className="cls-3"
                        d="m 269.34,273.08 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path219"/>
                    <path
                        className="cls-3"
                        d="m 281.59,271.7 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path220"/>
                    <path
                        className="cls-3"
                        d="m 294.87,270.42 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path221"/>
                    <path
                        className="cls-3"
                        d="m 307.38,267.6 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path222"/>
                    <path
                        className="cls-3"
                        d="m 319.63,262.8 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path223"/>
                </g>
                <path
                    className="cls-7"
                    d="m 120.4176,134.80329 c 0,0 0,0.0228 0,0.0341 0,3.20852 -13.67983,5.81023 -30.553005,5.81023 -16.873179,0 -30.553008,-2.60171 -30.553008,-5.81023 q 0,-0.0493 0,-0.0948 l 0.09102,-6.97455 h 61.113603 z"
                    id="path224"
                    />
                <path
                    className="cls-8"
                    d="m 120.4176,134.18131 c 0,0 0,0.0228 0,0.0341 0,3.20852 -13.67983,5.81023 -30.553005,5.81023 -16.873179,0 -30.553008,-2.60171 -30.553008,-5.81023 q 0,-0.0493 0,-0.0948 l 0.09102,-6.97455 h 61.113603 z"
                    id="path225"
                    />
                <ellipse
                    className="cls-7"
                    cx="89.959404"
                    cy="127.14608"
                    rx="30.553007"
                    ry="5.8102293"
                    id="ellipse225"
                    />
                <path
                    className="cls-9"
                    d="m 61.67057,136.24827 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94815 z"
                    id="path226"
                    />
                <path
                    className="cls-9"
                    d="m 71.648843,138.63 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 A 0.9481445,0.9481445 0 0 1 71.648843,138.63 Z"
                    id="path227"
                    />
                <path
                    className="cls-9"
                    d="m 66.612299,137.64393 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path228"
                    />
                <path
                    className="cls-9"
                    d="m 76.298544,139.10028 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94814 z"
                    id="path229"
                    />
                <path
                    className="cls-9"
                    d="m 81.043059,139.60849 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94815 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94814 z"
                    id="path230"
                    />
                <path
                    className="cls-9"
                    d="m 85.984788,139.9081 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94814 z"
                    id="path231"
                    />
                <path
                    className="cls-9"
                    d="m 90.824117,140.03705 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path232"
                    />
                <path
                    className="cls-9"
                    d="m 95.765847,139.9612 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94815 z"
                    id="path233"
                    />
                <path
                    className="cls-9"
                    d="m 100.70378,139.42645 a 0.9481445,0.9481445 0 0 1 -0.948141,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948141,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94815 z"
                    id="path234"
                    />
                <path
                    className="cls-9"
                    d="m 105.36865,138.91445 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94815 z"
                    id="path235"
                    />
                <path
                    className="cls-9"
                    d="m 110.38623,138.42521 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94815 z"
                    id="path236"
                    />
                <path
                    className="cls-9"
                    d="m 115.13075,137.3557 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94815 z"
                    id="path237"
                    />
                <path
                    className="cls-9"
                    d="m 119.78045,135.53526 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94814 z"
                    id="path238"
                    />
                <path
                    className="cls-3"
                    d="m 89.23882,141.43272 c -14.487648,0 -30.272358,-2.0973 -31.000533,-5.98848 a 0.47457264,0.47457264 0 1 1 0.932974,-0.17446 c 0.409599,2.18453 11.085706,5.2148 30.067559,5.2148 18.98185,0 29.68072,-3.03407 30.07135,-5.21859 a 0.47407225,0.47407225 0 0 1 0.93297,0.16687 c -0.69024,3.89498 -16.49012,5.99986 -31.00432,5.99986 z"
                    id="path239"
                    />
                <path
                    className="cls-3"
                    d="m 89.23882,140.81074 c -15.041365,0 -31.027081,-2.20349 -31.027081,-6.2843 q 0,-0.0683 0,-0.13275 l 0.03413,-2.77616 a 0.47407225,0.47407225 0 0 1 0.474073,-0.46649 v 0 a 0.47407225,0.47407225 0 0 1 0.466487,0.48166 l -0.03793,2.80651 c 0,0.0493 0,0.072 0,0.091 0,2.18073 10.71024,5.33615 30.078936,5.33615 19.368695,0 30.078935,-3.15542 30.078935,-5.33615 v -0.0341 l 0.0986,-7.03523 a 0.47407225,0.47407225 0 0 1 0.47407,-0.46648 v 0 a 0.47407225,0.47407225 0 0 1 0.46648,0.48165 l -0.0759,7.02006 c 0,4.11116 -15.98571,6.31465 -31.030867,6.31465 z"
                    id="path240"
                    />
                <path
                    className="cls-3"
                    d="m 58.769248,128.93238 v 0 a 0.47407225,0.47407225 0 0 1 -0.466487,-0.48165 l 0.01896,-1.47153 h 0.625775 a 0.47407225,0.47407225 0 0 1 0.310992,0.83058 v 0.65232 a 0.47407225,0.47407225 0 0 1 -0.489243,0.47028 z"
                    id="path241"
                    />
                <path
                    className="cls-3"
                    d="m 89.337427,133.73758 c -15.041365,0 -31.027081,-2.20349 -31.027081,-6.2843 0,-4.08082 15.985716,-6.2843 31.027081,-6.2843 15.041363,0 31.027083,2.20348 31.027083,6.2843 0,4.08081 -15.98572,6.2843 -31.027083,6.2843 z m 0,-11.62046 c -19.368696,0 -30.078936,3.15542 -30.078936,5.33616 0,2.18073 10.71024,5.33615 30.078936,5.33615 19.368693,0 30.063763,-3.15163 30.063763,-5.33236 0,-2.18073 -10.69507,-5.33616 -30.063763,-5.33616 z"
                    id="path242"
                    />
                <g
                    className="cls-6"
                    id="g255"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <path
                        className="cls-3"
                        d="m 158.14,242.94 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path243"/>
                    <path
                        className="cls-3"
                        d="m 184.45,249.22 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path244"/>
                    <path
                        className="cls-3"
                        d="m 171.17,246.62 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path245"/>
                    <path
                        className="cls-3"
                        d="m 196.71,250.46 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path246"/>
                    <path
                        className="cls-3"
                        d="m 209.22,251.8 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path247"/>
                    <path
                        className="cls-3"
                        d="m 222.24,252.6 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path248"/>
                    <path
                        className="cls-3"
                        d="m 235,252.93 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path249"/>
                    <path
                        className="cls-3"
                        d="m 248,252.73 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path250"/>
                    <path
                        className="cls-3"
                        d="m 261.06,251.35 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path251"/>
                    <path
                        className="cls-3"
                        d="m 273.31,250 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 V 248 a 2,2 0 0 1 -2,2 z"
                        id="path252"/>
                    <path
                        className="cls-3"
                        d="m 286.59,248.68 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path253"/>
                    <path
                        className="cls-3"
                        d="m 299.1,245.86 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path254"/>
                    <path
                        className="cls-3"
                        d="m 311.35,241.06 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path255"/>
                </g>
                <path
                    className="cls-7"
                    d="m 124.73356,126.56202 c 0,0 0,0.0228 0,0.0341 0,3.20853 -13.67983,5.81023 -30.553011,5.81023 -16.87318,0 -30.553008,-2.6017 -30.553008,-5.81023 q 0,-0.0493 0,-0.0948 l 0.09102,-6.97455 h 61.113599 z"
                    id="path256"
                    />
                <path
                    className="cls-8"
                    d="m 124.73356,125.93625 c 0,0 0,0.0228 0,0.0341 0,3.20852 -13.67983,5.81023 -30.553011,5.81023 -16.87318,0 -30.553008,-2.60171 -30.553008,-5.81023 q 0,-0.0493 0,-0.0948 l 0.09102,-6.97455 h 61.113599 z"
                    id="path257"
                    />
                <ellipse
                    className="cls-7"
                    cx="94.279152"
                    cy="118.90102"
                    rx="30.553007"
                    ry="5.8102293"
                    id="ellipse257"
                    />
                <path
                    className="cls-9"
                    d="m 65.990317,128.00699 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94814 z"
                    id="path258"
                    />
                <path
                    className="cls-9"
                    d="m 75.968589,130.38494 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path259"
                    />
                <path
                    className="cls-9"
                    d="m 70.928253,129.40266 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path260"
                    />
                <path
                    className="cls-9"
                    d="m 80.614497,130.85522 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94815 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path261"
                    />
                <path
                    className="cls-9"
                    d="m 85.362805,131.36342 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path262"
                    />
                <path
                    className="cls-9"
                    d="m 90.300742,131.66683 a 0.9481445,0.9481445 0 0 1 -0.948145,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.948145,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.948144,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948144,0.94814 z"
                    id="path263"
                    />
                <path
                    className="cls-9"
                    d="m 95.128693,131.79578 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94056 v 0 a 0.9481445,0.9481445 0 0 1 0.948145,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.948145,0.94814 z"
                    id="path264"
                    />
                <path
                    className="cls-9"
                    d="m 100.0818,131.71993 a 0.9481445,0.9481445 0 0 1 -0.948144,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.948144,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94815 z"
                    id="path265"
                    />
                <path
                    className="cls-9"
                    d="m 105.01974,131.19276 a 0.9481445,0.9481445 0 0 1 -0.94815,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94815,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94815 z"
                    id="path266"
                    />
                <path
                    className="cls-9"
                    d="m 109.66944,130.66938 a 0.9481445,0.9481445 0 0 1 -0.94815,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.94815,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.94814,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.94814,0.94814 z"
                    id="path267"
                    />
                <path
                    className="cls-9"
                    d="m 114.70598,130.18393 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94814 v -4.89243 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94814 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94814 v 4.89243 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94814 z"
                    id="path268"
                    />
                <path
                    className="cls-9"
                    d="m 119.4467,129.11443 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94815 z"
                    id="path269"
                    />
                <path
                    className="cls-9"
                    d="m 124.09261,127.2902 a 0.9481445,0.9481445 0 0 1 -0.94814,-0.94815 v -4.89242 a 0.9481445,0.9481445 0 0 1 0.94814,-0.94815 v 0 a 0.9481445,0.9481445 0 0 1 0.94815,0.94815 v 4.89242 a 0.9481445,0.9481445 0 0 1 -0.94815,0.94815 z"
                    id="path270"
                    />
                <path
                    className="cls-3"
                    d="m 93.558566,133.19145 c -14.487648,0 -30.27615,-2.0973 -31.000532,-5.98848 a 0.47457264,0.47457264 0 1 1 0.932974,-0.17446 c 0.409598,2.18452 11.085705,5.21479 30.067558,5.21479 18.981854,0 29.680714,-3.03406 30.071354,-5.21858 a 0.47407225,0.47407225 0 0 1 0.93297,0.16687 c -0.69025,3.89118 -16.49013,5.99986 -31.004324,5.99986 z"
                    id="path271"
                    />
                <path
                    className="cls-3"
                    d="m 93.558566,132.56946 c -15.041364,0 -31.027081,-2.20348 -31.027081,-6.2843 0,-0.0455 0,-0.091 0,-0.13274 l 0.09861,-7.41069 h 0.640945 a 0.47407225,0.47407225 0 0 1 0.310992,0.83057 l -0.08723,6.62184 c 0,0.0493 0,0.0721 0,0.091 0,2.18074 10.710241,5.33616 30.078936,5.33616 19.368692,0 30.078932,-3.15542 30.078932,-5.33616 v -0.0417 l 0.0986,-7.03523 a 0.47407225,0.47407225 0 0 1 0.47407,-0.46648 v 0 a 0.47407225,0.47407225 0 0 1 0.46649,0.48165 l -0.0986,7.03523 c -0.008,4.10737 -15.9933,6.31085 -31.034662,6.31085 z"
                    id="path272"
                    />
                <path
                    className="cls-3"
                    d="m 93.653381,125.49631 c -15.041365,0 -31.027081,-2.20349 -31.027081,-6.2843 a 1.6042605,1.6042605 0 0 1 0,-0.18963 0.47407225,0.47407225 0 0 1 0.940559,0.10998 0.69783435,0.69783435 0 0 0 0,0.0797 c 0,2.18073 10.710241,5.33615 30.078936,5.33615 19.368695,0 30.078935,-3.15542 30.078935,-5.33615 0,-2.18074 -10.71024,-5.33616 -30.078935,-5.33616 -12.894765,0 -24.378691,1.53599 -28.607415,3.82671 a 0.47430484,0.47430484 0 0 1 -0.451317,-0.83437 c 4.357672,-2.35519 16.03502,-3.94049 29.058732,-3.94049 15.041365,0 31.027085,2.20349 31.027085,6.28431 0,4.08081 -15.97434,6.2843 -31.019499,6.2843 z"
                    id="path273"
                    />
                <g
                    className="cls-6"
                    id="g286"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <path
                        className="cls-3"
                        d="m 169.52,221.21 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path274"/>
                    <path
                        className="cls-3"
                        d="m 195.83,227.48 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path275"/>
                    <path
                        className="cls-3"
                        d="m 182.55,224.89 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path276"/>
                    <path
                        className="cls-3"
                        d="m 208.09,228.72 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path277"/>
                    <path
                        className="cls-3"
                        d="m 220.61,230.06 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path278"/>
                    <path
                        className="cls-3"
                        d="m 233.63,230.86 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path279"/>
                    <path
                        className="cls-3"
                        d="m 246.4,231.2 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path280"/>
                    <path
                        className="cls-3"
                        d="m 259.42,231 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 V 229 a 2,2 0 0 1 -2,2 z"
                        id="path281"/>
                    <path
                        className="cls-3"
                        d="m 272.44,229.62 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path282"/>
                    <path
                        className="cls-3"
                        d="m 284.7,228.23 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path283"/>
                    <path
                        className="cls-3"
                        d="m 298,227 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 V 225 a 2,2 0 0 1 -2,2 z"
                        id="path284"/>
                    <path
                        className="cls-3"
                        d="m 310.48,224.13 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path285"/>
                    <path
                        className="cls-3"
                        d="m 322.73,219.33 a 2,2 0 0 1 -2,-2 v -12.9 a 2,2 0 0 1 2,-2 v 0 a 2,2 0 0 1 2,2 v 12.9 a 2,2 0 0 1 -2,2 z"
                        id="path286"/>
                </g>
                <path
                    className="cls-7"
                    d="m 135.82306,125.07912 v 0.0341 c -0.47787,3.17438 -14.4118,3.70155 -31.08018,1.17949 -16.668382,-2.52207 -29.824835,-7.13763 -29.335592,-10.31202 q 0,-0.0493 0,-0.0948 l 1.137773,-6.87973 60.423349,9.13253 z"
                    id="path287"
                    />
                <path
                    className="cls-8"
                    d="m 135.91787,124.46473 v 0.0341 c -0.47787,3.17439 -14.4118,3.70155 -31.08018,1.17949 C 88.169313,123.15626 75.02803,118.5369 75.490725,115.3663 q 0,-0.0493 0,-0.0948 l 1.137773,-6.87974 60.423352,9.13253 z"
                    id="path288"
                    />
                <ellipse
                    className="cls-7"
                    cx="-95.721985"
                    cy="122.51852"
                    rx="5.8102293"
                    ry="30.553007"
                    transform="rotate(-81.409999)"
                    id="ellipse288"
                    />
                <path
                    className="cls-9"
                    d="m 77.682835,117.74048 h -0.140326 a 0.9481445,0.9481445 0 0 1 -0.796441,-1.07709 l 0.724382,-4.83933 a 0.94909407,0.94909407 0 0 1 1.877326,0.28065 l -0.724382,4.83933 a 0.9481445,0.9481445 0 0 1 -0.940559,0.79644 z"
                    id="path289"
                    />
                <path
                    className="cls-9"
                    d="m 87.16428,121.60133 h -0.140326 a 0.9481445,0.9481445 0 0 1 -0.796441,-1.07709 l 0.724382,-4.83933 a 0.94909407,0.94909407 0 1 1 1.877326,0.28065 l -0.724382,4.83933 a 0.9481445,0.9481445 0 0 1 -0.940559,0.79644 z"
                    id="path290"
                    />
                <path
                    className="cls-9"
                    d="m 82.343913,119.85674 h -0.140325 a 0.9481445,0.9481445 0 0 1 -0.796442,-1.07709 l 0.724383,-4.83933 a 0.94909407,0.94909407 0 1 1 1.877326,0.28065 l -0.724383,4.83933 a 0.9481445,0.9481445 0 0 1 -0.940559,0.79644 z"
                    id="path291"
                    />
                <path
                    className="cls-9"
                    d="m 91.715373,122.7391 h -0.140325 a 0.9481445,0.9481445 0 0 1 -0.796442,-1.07709 l 0.724383,-4.83933 a 0.94909407,0.94909407 0 0 1 1.877326,0.28065 l -0.724382,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path292"
                    />
                <path
                    className="cls-9"
                    d="m 96.319563,123.95652 h -0.140325 a 0.9481445,0.9481445 0 0 1 -0.796442,-1.07709 l 0.724383,-4.83933 a 0.94909407,0.94909407 0 1 1 1.877326,0.28065 l -0.724383,4.83933 a 0.9481445,0.9481445 0 0 1 -0.940559,0.79644 z"
                    id="path293"
                    />
                <path
                    className="cls-9"
                    d="m 101.1551,124.99189 h -0.14033 a 0.9481445,0.9481445 0 0 1 -0.79644,-1.07709 l 0.72439,-4.83933 a 0.94909407,0.94909407 0 0 1 1.87732,0.28065 l -0.72438,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path294"
                    />
                <path
                    className="cls-9"
                    d="m 105.92616,125.84522 h -0.14032 a 0.9481445,0.9481445 0 0 1 -0.79644,-1.07709 l 0.72438,-4.83933 a 0.94909407,0.94909407 0 0 1 1.87732,0.28065 l -0.72438,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path295"
                    />
                <path
                    className="cls-9"
                    d="m 110.82238,126.50513 h -0.14032 a 0.9481445,0.9481445 0 0 1 -0.79645,-1.07709 l 0.72439,-4.83933 a 0.94909407,0.94909407 0 1 1 1.87732,0.28065 l -0.72438,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path296"
                    />
                <path
                    className="cls-9"
                    d="m 115.78307,126.7251 h -0.14032 a 0.9481445,0.9481445 0 0 1 -0.79644,-1.07709 l 0.72438,-4.83933 a 0.94909407,0.94909407 0 1 1 1.87732,0.28065 l -0.72438,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path297"
                    />
                <path
                    className="cls-9"
                    d="m 120.45553,126.91094 h -0.14033 a 0.9481445,0.9481445 0 0 1 -0.79644,-1.07709 l 0.72438,-4.83933 a 0.94909593,0.94909593 0 0 1 1.87733,0.28065 l -0.72438,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path298"
                    />
                <path
                    className="cls-9"
                    d="m 125.50724,127.17263 h -0.14032 a 0.9481445,0.9481445 0 0 1 -0.79644,-1.0771 l 0.72438,-4.83933 a 0.94909407,0.94909407 0 0 1 1.87732,0.28066 l -0.72438,4.83932 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79645 z"
                    id="path299"
                    />
                <path
                    className="cls-9"
                    d="m 130.35795,126.82371 h -0.14032 a 0.9481445,0.9481445 0 0 1 -0.79645,-1.07709 l 0.72439,-4.83933 a 0.94909407,0.94909407 0 1 1 1.87732,0.28065 l -0.72438,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path300"
                    />
                <path
                    className="cls-9"
                    d="m 135.22383,125.72007 h -0.14033 a 0.9481445,0.9481445 0 0 1 -0.79644,-1.07709 l 0.72438,-4.83933 a 0.94909593,0.94909593 0 0 1 1.87733,0.28065 l -0.72438,4.83933 a 0.9481445,0.9481445 0 0 1 -0.94056,0.79644 z"
                    id="path301"
                    />
                <path
                    className="cls-3"
                    d="m 123.09516,128.56071 a 133.878,133.878 0 0 1 -19.08804,-1.5853 C 89.682551,124.80985 74.387084,120.37633 74.250552,116.42067 a 0.47437935,0.47437935 0 0 1 0.948144,-0.0341 c 0.07585,2.22246 10.179279,6.82664 28.952544,9.64832 18.77326,2.82168 29.80207,1.43739 30.51129,-0.66749 a 0.474334,0.474334 0 0 1 0.89884,0.30341 c -0.69025,2.04419 -5.71921,2.88994 -12.46621,2.88994 z"
                    id="path302"
                    />
                <path
                    className="cls-3"
                    d="m 123.19377,127.9539 a 133.70734,133.70734 0 0 1 -19.07667,-1.59289 c -8.097151,-1.225 -15.625418,-2.97717 -21.192923,-4.93035 -5.946762,-2.08971 -8.825329,-4.08081 -8.544678,-5.91642 0,-0.0455 0,-0.091 0.02655,-0.13653 l 1.202247,-7.30451 0.618191,0.091 a 0.47407225,0.47407225 0 0 1 0.185836,0.8685 l -1.077092,6.53461 c 0,0.0531 0,0.0721 0,0.0872 -0.144118,0.96331 1.858363,2.74962 7.922695,4.88104 5.514409,1.93801 12.981995,3.67501 21.022254,4.88864 19.15252,2.89373 30.21547,1.3767 30.54163,-0.78127 v -0.0379 l 1.13778,-6.94421 a 0.47479231,0.47479231 0 1 1 0.93676,0.1555 l -1.13777,6.94421 c -0.37546,2.25658 -5.52199,3.19335 -12.56481,3.19335 z"
                    id="path303"
                    />
                <path
                    className="cls-3"
                    d="m 124.36188,120.97935 a 133.99178,133.99178 0 0 1 -19.1108,-1.59668 c -8.09715,-1.225 -15.625417,-2.97717 -21.192922,-4.93035 -5.946762,-2.08971 -8.825329,-4.08081 -8.544678,-5.91642 0.610605,-4.03531 16.748024,-3.82671 31.61872,-1.57771 8.09716,1.225 15.62542,2.97717 21.19293,4.93035 5.94676,2.08971 8.82533,4.08081 8.54468,5.91642 v 0 c -0.33754,2.2452 -5.46511,3.17439 -12.50793,3.17439 z M 88.264127,106.29828 c -7.482756,0 -11.616666,1.0733 -11.81388,2.37794 -0.144118,0.96332 1.858363,2.74962 7.922695,4.88105 5.514409,1.93801 12.981995,3.67501 21.022258,4.88863 19.14873,2.89374 30.21547,1.37671 30.54163,-0.78127 0.14412,-0.96331 -1.85836,-2.74962 -7.92269,-4.88104 -5.51441,-1.93801 -12.982,-3.67501 -21.02226,-4.88864 a 127.95779,127.95779 0 0 0 -18.727753,-1.59667 z m 48.139193,11.43841 z"
                    id="path304"
                    />
                <g
                    className="cls-6"
                    id="g317"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <path
                        className="cls-3"
                        d="m 200.21,193.89 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 0 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.68 z"
                        id="path305"/>
                    <path
                        className="cls-3"
                        d="m 225.28,204 h -0.3 a 2,2 0 0 1 -1.68,-2.27 L 225.21,189 a 2.0216392,2.0216392 0 1 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.65 z"
                        id="path306"/>
                    <path
                        className="cls-3"
                        d="m 212.54,199.47 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 0 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.68 z"
                        id="path307"/>
                    <path
                        className="cls-3"
                        d="m 237.22,207.08 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.9,-12.81 a 2.0216392,2.0216392 0 1 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.01,1.73 z"
                        id="path308"/>
                    <path
                        className="cls-3"
                        d="m 249.39,210.27 h -0.3 A 2,2 0 0 1 247.41,208 l 1.91,-12.76 a 2.0216392,2.0216392 0 1 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.68 z"
                        id="path309"/>
                    <path
                        className="cls-3"
                        d="m 262.15,213 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.9,-12.73 a 2.0216392,2.0216392 0 0 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.01,1.65 z"
                        id="path310"/>
                    <path
                        className="cls-3"
                        d="m 274.72,215.25 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 0 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.68 z"
                        id="path311"/>
                    <path
                        className="cls-3"
                        d="m 287.63,217 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 1 1 4,0.59 l -1.96,12.74 a 2,2 0 0 1 -1.97,1.7 z"
                        id="path312"/>
                    <path
                        className="cls-3"
                        d="m 300.71,217.58 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 1 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.68 z"
                        id="path313"/>
                    <path
                        className="cls-3"
                        d="m 313,218 h -0.3 a 2,2 0 0 1 -1.68,-2.27 L 313,203 a 2.0216392,2.0216392 0 1 1 4,0.59 l -2,12.75 a 2,2 0 0 1 -2,1.66 z"
                        id="path314"/>
                    <path
                        className="cls-3"
                        d="m 326.35,218.76 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 1 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.68 z"
                        id="path315"/>
                    <path
                        className="cls-3"
                        d="m 339.14,217.84 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 0 1 4,0.59 l -1.91,12.76 a 2,2 0 0 1 -2.02,1.68 z"
                        id="path316"/>
                    <path
                        className="cls-3"
                        d="m 352,214.92 h -0.3 a 2,2 0 0 1 -1.68,-2.27 l 1.91,-12.76 a 2.0216392,2.0216392 0 1 1 4,0.59 L 354,213.22 a 2,2 0 0 1 -2,1.7 z"
                        id="path317"/>
                </g>
                <path
                    className="cls-8"
                    d="m 104.23088,108.60037 c 0.96332,0.23135 1.76734,0.44753 2.41967,0.64474 0.65232,0.19721 1.24017,0.39822 1.737,0.59164 a 8.4536564,8.4536564 0 0 1 2.16935,1.13778 l -2.22245,-0.53476 a 8.8822177,8.8822177 0 0 0 -2.43863,-1.02399 q -0.62577,-0.18963 -1.69149,-0.44753 c -0.713,-0.17066 -1.33878,-0.29582 -1.89629,-0.37926 a 8.3436716,8.3436716 0 0 0 -1.31602,-0.10619 c -0.52338,0 -0.87229,0.14791 -1.04296,0.4096 l -0.292028,0.44752 5.275478,1.26293 0.0303,0.50062 -5.559921,-1.34257 -1.69149,2.58275 15.208241,3.66742 0.88367,1.45256 -25.26995,-6.10226 1.32361,-0.75852 4.190799,0.86471 2.597916,-2.38174 -2.654805,-0.64474 0.576472,-0.35271 2.522064,0.60682 0.47028,-0.42857 c 0.379258,-0.33374 1.099848,-0.46648 2.173147,-0.42856 a 23.775671,23.775671 0 0 1 4.497997,0.76231 z"
                    id="path318"
                    />
                <path
                    className="cls-7"
                    d="m 146.10473,130.26737 v 0.0303 c -1.51703,2.82926 -14.79105,-1.3274 -29.6845,-9.28802 -14.89346,-7.96062 -25.713683,-16.68735 -24.200444,-19.53557 l 0.0493,-0.0834 3.371601,-6.10605 53.884953,28.82359 z"
                    id="path319"
                    />
                <path
                    className="cls-8"
                    d="m 146.40056,129.71745 v 0.0303 c -1.51704,2.82926 -14.79106,-1.32741 -29.68451,-9.28803 -14.89346,-7.96062 -25.713681,-16.68734 -24.200443,-19.53557 l 0.0493,-0.0834 3.371602,-6.106053 53.884951,28.823593 z"
                    id="path320"
                    />
                <ellipse
                    className="cls-7"
                    cx="-38.296345"
                    cy="159.81221"
                    rx="5.8102293"
                    ry="30.553007"
                    transform="rotate(-61.86)"
                    id="ellipse320"
                    />
                <path
                    className="cls-9"
                    d="m 94.070564,103.94688 a 0.9481445,0.9481445 0 0 1 -0.834367,-1.39567 l 2.302095,-4.319746 a 0.9481445,0.9481445 0 0 1 1.672527,0.891255 l -2.302095,4.319751 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50441 z"
                    id="path321"
                    />
                <path
                    className="cls-9"
                    d="m 101.74674,110.75076 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39567 l 2.3021,-4.31974 a 0.9481445,0.9481445 0 1 1 1.67253,0.89125 l -2.3021,4.31975 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50441 z"
                    id="path322"
                    />
                <path
                    className="cls-9"
                    d="m 97.783498,107.50811 a 0.9481445,0.9481445 0 0 1 -0.834367,-1.39567 l 2.302095,-4.31975 a 0.9481445,0.9481445 0 0 1 1.672524,0.89126 l -2.302092,4.31975 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50441 z"
                    id="path323"
                    />
                <path
                    className="cls-9"
                    d="m 105.62276,113.36006 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39567 l 2.30209,-4.31975 a 0.9481445,0.9481445 0 0 1 1.67253,0.89126 l -2.30209,4.31974 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50442 z"
                    id="path324"
                    />
                <path
                    className="cls-9"
                    d="m 109.57083,116.0452 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39567 l 2.3021,-4.31974 a 0.9481445,0.9481445 0 1 1 1.67253,0.89125 l -2.30589,4.31216 a 0.9481445,0.9481445 0 0 1 -0.83437,0.512 z"
                    id="path325"
                    />
                <path
                    className="cls-9"
                    d="m 113.78059,118.64312 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39567 l 2.28314,-4.31975 a 0.9481445,0.9481445 0 0 1 1.67252,0.89126 l -2.30209,4.31595 a 0.9481445,0.9481445 0 0 1 -0.8192,0.50821 z"
                    id="path326"
                    />
                <path
                    className="cls-9"
                    d="m 117.99035,121.04003 a 0.9481445,0.9481445 0 0 1 -0.83436,-1.39567 l 2.30209,-4.31595 a 0.9481445,0.9481445 0 0 1 1.67253,0.89125 l -2.3021,4.31595 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50442 z"
                    id="path327"
                    />
                <path
                    className="cls-9"
                    d="m 122.38216,123.3004 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39566 l 2.3021,-4.31975 a 0.9481445,0.9481445 0 0 1 1.67252,0.89125 l -2.30209,4.31975 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50441 z"
                    id="path328"
                    />
                <path
                    className="cls-9"
                    d="m 126.98635,125.16635 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39567 l 2.3021,-4.31974 a 0.9481445,0.9481445 0 1 1 1.67252,0.89125 l -2.30209,4.31975 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50441 z"
                    id="path329"
                    />
                <path
                    className="cls-9"
                    d="m 131.32885,126.91094 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39567 l 2.3021,-4.31595 a 0.9481445,0.9481445 0 1 1 1.67252,0.89125 l -2.30209,4.31596 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50441 z"
                    id="path330"
                    />
                <path
                    className="cls-9"
                    d="m 135.99751,128.84515 a 0.9481445,0.9481445 0 0 1 -0.83436,-1.39567 l 2.30209,-4.33112 a 0.9481445,0.9481445 0 0 1 1.67253,0.89126 l -2.29072,4.33112 a 0.9481445,0.9481445 0 0 1 -0.84954,0.50441 z"
                    id="path331"
                    />
                <path
                    className="cls-9"
                    d="m 140.68893,130.13842 a 0.9481445,0.9481445 0 0 1 -0.83436,-1.39567 l 2.30209,-4.31595 a 0.9481445,0.9481445 0 0 1 1.67253,0.89126 l -2.3021,4.31595 a 0.9481445,0.9481445 0 0 1 -0.83816,0.50441 z"
                    id="path332"
                    />
                <path
                    className="cls-9"
                    d="m 145.64204,130.72627 a 0.9481445,0.9481445 0 0 1 -0.83437,-1.39567 l 2.2983,-4.31595 a 0.9481445,0.9481445 0 1 1 1.67253,0.89126 l -2.30209,4.31974 a 0.9481445,0.9481445 0 0 1 -0.83437,0.50062 z"
                    id="path333"
                    />
                <path
                    className="cls-3"
                    d="m 142.91518,131.62132 c -5.43856,0 -17.1197,-4.7028 -27.42414,-10.21341 -12.77719,-6.83044 -25.706089,-16.11467 -24.51522,-19.90724 a 0.47407225,0.47407225 0 1 1 0.902634,0.28444 c -0.671286,2.12005 7.315883,9.82657 24.056326,18.78085 15.37131,8.2223 27.39379,11.59011 28.97529,9.58005 a 0.47982294,0.47982294 0 1 1 0.75852,0.58785 c -0.47787,0.61439 -1.44118,0.88746 -2.75341,0.88746 z"
                    id="path334"
                    />
                <path
                    className="cls-3"
                    d="m 143.16928,131.08277 c -5.43856,0 -16.98696,-4.64211 -27.38621,-10.20582 -7.2059,-3.86464 -13.72913,-8.03268 -18.321941,-11.75699 -4.907596,-3.95946 -6.948003,-6.8001 -6.068125,-8.43849 l 0.06827,-0.11757 3.580194,-6.489102 0.549924,0.295821 a 0.47407225,0.47407225 0 0 1 -0.11757,0.879878 l -3.200936,5.798853 -0.04551,0.0759 c -0.458902,0.86092 0.830575,3.21611 5.832985,7.25141 4.551099,3.67122 10.998479,7.80513 18.174039,11.64321 17.06659,9.13632 28.01197,11.40808 29.03976,9.48145 v -0.0341 l 3.41332,-6.15915 a 0.47445894,0.47445894 0 1 1 0.83057,0.4589 l -3.41332,6.15915 c -0.4058,0.77748 -1.43737,1.15673 -2.93545,1.15673 z"
                    id="path335"
                    />
                <path
                    className="cls-3"
                    d="m 146.60156,124.88949 c -5.42338,0 -16.98695,-4.6459 -27.40137,-10.2172 -7.2059,-3.86464 -13.72914,-8.03268 -18.32195,-11.75699 -4.907594,-3.959454 -6.948001,-6.800095 -6.068123,-8.438489 1.831815,-3.41332 14.973093,1.896289 18.962893,3.599157 a 0.47558733,0.47558733 0 1 1 -0.37926,0.872293 c -11.11984,-4.771063 -16.994543,-5.430972 -17.749266,-4.020133 -0.458902,0.857123 0.830575,3.216106 5.832986,7.251412 4.55109,3.67121 10.99848,7.80512 18.17403,11.64321 17.0666,9.13632 28.01198,11.40808 29.03977,9.48145 1.02779,-1.92663 -6.91387,-9.74314 -24.00702,-18.87946 -2.76858,-1.4791 -5.53716,-2.8596 -8.23748,-4.09977 a 0.47407225,0.47407225 0 1 1 0.37926,-0.860919 c 2.71549,1.247759 5.50303,2.654809 8.28679,4.126329 13.27402,7.09591 26.32049,16.57735 24.39765,20.17651 -0.39822,0.77369 -1.42222,1.1226 -2.90891,1.1226 z"
                    id="path336"
                    />
                <g
                    className="cls-6"
                    id="g349"
                    transform="matrix(0.3792578,0,0,0.3792578,1.072759,44.232738)">
                    <path
                        className="cls-3"
                        d="m 243.38,156.9 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.39 a 2,2 0 0 1 3.53,1.88 l -6.07,11.39 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path337"/>
                    <path
                        className="cls-3"
                        d="m 263.61,174.84 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.39 a 2,2 0 0 1 3.53,1.88 l -6.07,11.39 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path338"/>
                    <path
                        className="cls-3"
                        d="m 253.13,166.28 a 2,2 0 0 1 -1.76,-2.94 L 257.43,152 a 2,2 0 1 1 3.53,1.88 l -6.06,11.38 a 2,2 0 0 1 -1.77,1.02 z"
                        id="path339"/>
                    <path
                        className="cls-3"
                        d="m 273.84,181.71 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.38 a 2,2 0 1 1 3.53,1.88 l -6.07,11.38 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path340"/>
                    <path
                        className="cls-3"
                        d="m 284.24,188.8 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.39 a 2,2 0 1 1 3.53,1.88 L 286,187.74 a 2,2 0 0 1 -1.76,1.06 z"
                        id="path341"/>
                    <path
                        className="cls-3"
                        d="m 295.35,195.64 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.38 a 2,2 0 0 1 3.53,1.88 l -6.07,11.38 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path342"/>
                    <path
                        className="cls-3"
                        d="m 306.45,202 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.39 a 2,2 0 1 1 3.53,1.88 l -6.07,11.39 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path343"/>
                    <path
                        className="cls-3"
                        d="m 318,207.93 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.38 a 2,2 0 1 1 3.53,1.88 l -6.07,11.38 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path344"/>
                    <path
                        className="cls-3"
                        d="m 330.16,212.85 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.39 a 2,2 0 1 1 3.53,1.88 l -6.07,11.39 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path345"/>
                    <path
                        className="cls-3"
                        d="m 341.62,217.41 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.38 a 2,2 0 1 1 3.53,1.88 l -6.07,11.38 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path346"/>
                    <path
                        className="cls-3"
                        d="m 353.93,222.55 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.38 a 2,2 0 0 1 3.53,1.88 l -6.07,11.38 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path347"/>
                    <path
                        className="cls-3"
                        d="m 366.29,226 a 2,2 0 0 1 -1.76,-2.94 l 6.06,-11.38 a 2,2 0 1 1 3.53,1.88 l -6.06,11.38 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path348"/>
                    <path
                        className="cls-3"
                        d="m 379.36,227.5 a 2,2 0 0 1 -1.76,-2.94 l 6.07,-11.39 a 2,2 0 0 1 3.53,1.88 l -6.07,11.39 a 2,2 0 0 1 -1.77,1.06 z"
                        id="path349"/>
                </g>
                <path
                    className="cls-8"
                    d="m 126.60709,107.27297 q 1.29706,0.72438 2.15798,1.27431 0.86091,0.54992 1.51703,1.03916 a 8.4536564,8.4536564 0 0 1 1.78251,1.67253 l -1.9949,-1.11502 a 8.8822177,8.8822177 0 0 0 -2.07074,-1.64219 q -0.54993,-0.34891 -1.51703,-0.88746 c -0.64095,-0.3565 -1.20984,-0.64853 -1.71425,-0.8685 a 8.3436716,8.3436716 0 0 0 -1.23638,-0.4589 c -0.50821,-0.12516 -0.87988,-0.0948 -1.11502,0.10998 l -0.40201,0.35271 4.71797,2.65481 -0.1062,0.48924 -4.99103,-2.79134 -2.32485,2.02903 13.65328,7.63446 0.4589,1.6384 -22.6872,-12.68618 1.4829,-0.37926 3.79258,1.96456 3.15163,-1.57013 -2.39691,-1.33878 0.65232,-0.18583 2.27555,1.26672 0.56889,-0.28445 c 0.44373,-0.21997 1.18328,-0.1517 2.20728,0.17446 a 23.775671,23.775671 0 0 1 4.1377,1.90767 z"
                    id="path350"
                    />
                <path
                    className="cls-5"
                    d="m 130.0642,55.597554 h -1.45256 a 0.47407225,0.47407225 0 0 1 0,-0.948144 h 1.45256 a 0.47407225,0.47407225 0 0 1 0,0.948144 z"
                    id="path351"
                    />
                <path
                    className="cls-5"
                    d="m 184.70008,55.627895 v 0 l -53.50948,-0.03034 a 0.47407225,0.47407225 0 0 1 0,-0.948144 v 0 l 53.50948,0.03034 a 0.4740725,0.4740725 0 0 1 0,0.948144 z"
                    id="path352"
                    />
                <path
                    className="cls-5"
                    d="m 182.52693,55.589969 h -49.54244 v -0.511998 c 0,-0.03793 0,-0.07964 0,-0.11757 a 6.8683588,6.8683588 0 0 1 6.82664,-6.860774 6.758374,6.758374 0 0 1 2.6548,0.534754 7.6420447,7.6420447 0 0 1 10.77092,-3.197143 11.226031,11.226031 0 0 1 21.04881,1.414631 8.2716126,8.2716126 0 0 1 8.22989,8.264028 z m -48.60189,-0.932974 h 47.63858 a 7.3272607,7.3272607 0 0 0 -7.30072,-6.826641 h -0.30719 -0.37926 l -0.0948,-0.379258 a 10.277886,10.277886 0 0 0 -19.56591,-1.137773 l -0.21617,0.572679 -0.50062,-0.352709 a 6.6901076,6.6901076 0 0 0 -10.04654,2.9127 l -0.19722,0.474072 -0.45511,-0.231347 a 5.8443627,5.8443627 0 0 0 -2.6548,-0.640946 5.9202143,5.9202143 0 0 0 -5.92022,5.609223 z"
                    id="path353"
                    />
                <path
                    className="cls-5"
                    d="m 174.19843,52.669684 h -0.0531 a 0.47407225,0.47407225 0 0 1 -0.41718,-0.523376 10.915039,10.915039 0 0 0 0.0645,-1.179492 c 0,-0.178251 0,-0.352709 0,-0.530961 a 0.47462079,0.47462079 0 0 1 0.94815,-0.04551 q 0,0.288235 0,0.576471 a 11.791125,11.791125 0 0 1 -0.0721,1.285684 0.47407225,0.47407225 0 0 1 -0.47028,0.417184 z"
                    id="path354"
                    />
                <path
                    className="cls-5"
                    d="m 174.27428,49.55977 a 0.47407225,0.47407225 0 0 1 -0.47028,-0.424769 10.554745,10.554745 0 0 0 -0.4058,-1.968348 0.47443999,0.47443999 0 0 1 0.90642,-0.280651 11.510474,11.510474 0 0 1 0.44373,2.1466 0.47407225,0.47407225 0 0 1 -0.42476,0.527168 z"
                    id="path355"
                    />
                <path
                    className="cls-5"
                    d="m 146.74775,47.587629 a 0.47407225,0.47407225 0 0 1 -0.23514,-0.88367 5.8443627,5.8443627 0 0 1 2.3514,-0.807819 0.48165741,0.48165741 0 0 1 0.50062,0.447524 0.47407225,0.47407225 0 0 1 -0.45132,0.496827 5.032751,5.032751 0 0 0 -1.93421,0.686457 0.47407225,0.47407225 0 0 1 -0.23135,0.06068 z"
                    id="path356"
                    />
                <path
                    className="cls-5"
                    d="m 154.98144,48.69127 a 0.47407225,0.47407225 0 0 1 -0.42856,-0.273066 5.688867,5.688867 0 0 0 -0.69784,-1.137774 5.9012514,5.9012514 0 0 0 -0.92918,-0.932974 0.47473307,0.47473307 0 1 1 0.59544,-0.739552 6.8986994,6.8986994 0 0 1 1.08088,1.084677 6.6825224,6.6825224 0 0 1 0.8154,1.312232 0.47407225,0.47407225 0 0 1 -0.43614,0.686457 z"
                    id="path357"
                    />
                <path
                    className="cls-5"
                    d="m 142.46593,51.061631 h -0.0379 a 0.47407225,0.47407225 0 0 1 -0.43235,-0.511998 6.515649,6.515649 0 0 1 0.31858,-1.581505 0.47407225,0.47407225 0 1 1 0.89505,0.307199 5.59026,5.59026 0 0 0 -0.18205,0.663701 5.4347643,5.4347643 0 0 0 -0.0986,0.682664 0.47407225,0.47407225 0 0 1 -0.46269,0.439939 z"
                    id="path358"
                    />
            </svg>

        </div>
    )
};

export {CommissionImage};
